import ws, { isAxiosError as Xu } from "axios";
import { useMemo as Qu } from "react";
var yt = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Zu(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var Z = function(r) {
  try {
    return !!r();
  } catch {
    return !0;
  }
}, rl = Z, qe = !rl(function() {
  var r = (function() {
  }).bind();
  return typeof r != "function" || r.hasOwnProperty("prototype");
}), Is = qe, Ps = Function.prototype, Nn = Ps.call, el = Is && Ps.bind.bind(Nn, Nn), lr = Is ? el : function(r) {
  return function() {
    return Nn.apply(r, arguments);
  };
}, tl = lr, Rs = tl({}.isPrototypeOf), ge = function(r) {
  return r && r.Math === Math && r;
}, rr = (
  // eslint-disable-next-line es/no-global-this -- safe
  ge(typeof globalThis == "object" && globalThis) || ge(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
  ge(typeof self == "object" && self) || ge(typeof yt == "object" && yt) || // eslint-disable-next-line no-new-func -- fallback
  /* @__PURE__ */ function() {
    return this;
  }() || yt || Function("return this")()
), nl = qe, Cs = Function.prototype, Xa = Cs.apply, Qa = Cs.call, al = typeof Reflect == "object" && Reflect.apply || (nl ? Qa.bind(Xa) : function() {
  return Qa.apply(Xa, arguments);
}), As = lr, ol = As({}.toString), il = As("".slice), Je = function(r) {
  return il(ol(r), 8, -1);
}, sl = Je, cl = lr, Ds = function(r) {
  if (sl(r) === "Function") return cl(r);
}, kn = typeof document == "object" && document.all, ul = typeof kn > "u" && kn !== void 0, js = {
  all: kn,
  IS_HTMLDDA: ul
}, xs = js, ll = xs.all, er = xs.IS_HTMLDDA ? function(r) {
  return typeof r == "function" || r === ll;
} : function(r) {
  return typeof r == "function";
}, Ns = {}, vl = Z, Qr = !vl(function() {
  return Object.defineProperty({}, 1, { get: function() {
    return 7;
  } })[1] !== 7;
}), fl = qe, me = Function.prototype.call, la = fl ? me.bind(me) : function() {
  return me.apply(me, arguments);
}, ks = {}, Ms = {}.propertyIsEnumerable, Ls = Object.getOwnPropertyDescriptor, dl = Ls && !Ms.call({ 1: 2 }, 1);
ks.f = dl ? function(e) {
  var t = Ls(this, e);
  return !!t && t.enumerable;
} : Ms;
var Fs = function(r, e) {
  return {
    enumerable: !(r & 1),
    configurable: !(r & 2),
    writable: !(r & 4),
    value: e
  };
}, pl = lr, $l = Z, hl = Je, gt = Object, yl = pl("".split), gl = $l(function() {
  return !gt("z").propertyIsEnumerable(0);
}) ? function(r) {
  return hl(r) === "String" ? yl(r, "") : gt(r);
} : gt, Bs = function(r) {
  return r == null;
}, ml = Bs, bl = TypeError, va = function(r) {
  if (ml(r)) throw bl("Can't call method on " + r);
  return r;
}, Sl = gl, Ol = va, Us = function(r) {
  return Sl(Ol(r));
}, Za = er, Ks = js, _l = Ks.all, Zr = Ks.IS_HTMLDDA ? function(r) {
  return typeof r == "object" ? r !== null : Za(r) || r === _l;
} : function(r) {
  return typeof r == "object" ? r !== null : Za(r);
}, fa = {}, mt = fa, bt = rr, Tl = er, ro = function(r) {
  return Tl(r) ? r : void 0;
}, El = function(r, e) {
  return arguments.length < 2 ? ro(mt[r]) || ro(bt[r]) : mt[r] && mt[r][e] || bt[r] && bt[r][e];
}, wl = typeof navigator < "u" && String(navigator.userAgent) || "", Gs = rr, St = wl, eo = Gs.process, to = Gs.Deno, no = eo && eo.versions || to && to.version, ao = no && no.v8, L, Ke;
ao && (L = ao.split("."), Ke = L[0] > 0 && L[0] < 4 ? 1 : +(L[0] + L[1]));
!Ke && St && (L = St.match(/Edge\/(\d+)/), (!L || L[1] >= 74) && (L = St.match(/Chrome\/(\d+)/), L && (Ke = +L[1])));
var Il = Ke, oo = Il, Pl = Z, Rl = rr, Cl = Rl.String, Vs = !!Object.getOwnPropertySymbols && !Pl(function() {
  var r = Symbol("symbol detection");
  return !Cl(r) || !(Object(r) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && oo && oo < 41;
}), Al = Vs, Ws = Al && !Symbol.sham && typeof Symbol.iterator == "symbol", Dl = El, jl = er, xl = Rs, Nl = Ws, kl = Object, Ys = Nl ? function(r) {
  return typeof r == "symbol";
} : function(r) {
  var e = Dl("Symbol");
  return jl(e) && xl(e.prototype, kl(r));
}, Ml = String, Ll = function(r) {
  try {
    return Ml(r);
  } catch {
    return "Object";
  }
}, Fl = er, Bl = Ll, Ul = TypeError, Hs = function(r) {
  if (Fl(r)) return r;
  throw Ul(Bl(r) + " is not a function");
}, Kl = Hs, Gl = Bs, Vl = function(r, e) {
  var t = r[e];
  return Gl(t) ? void 0 : Kl(t);
}, Ot = la, _t = er, Tt = Zr, Wl = TypeError, Yl = function(r, e) {
  var t, n;
  if (e === "string" && _t(t = r.toString) && !Tt(n = Ot(t, r)) || _t(t = r.valueOf) && !Tt(n = Ot(t, r)) || e !== "string" && _t(t = r.toString) && !Tt(n = Ot(t, r))) return n;
  throw Wl("Can't convert object to primitive value");
}, zs = { exports: {} }, io = rr, Hl = Object.defineProperty, zl = function(r, e) {
  try {
    Hl(io, r, { value: e, configurable: !0, writable: !0 });
  } catch {
    io[r] = e;
  }
  return e;
}, ql = rr, Jl = zl, so = "__core-js_shared__", Xl = ql[so] || Jl(so, {}), Ql = Xl, co = Ql;
(zs.exports = function(r, e) {
  return co[r] || (co[r] = e !== void 0 ? e : {});
})("versions", []).push({
  version: "3.32.1",
  mode: "pure",
  copyright: "© 2014-2023 Denis Pushkarev (zloirock.ru)",
  license: "https://github.com/zloirock/core-js/blob/v3.32.1/LICENSE",
  source: "https://github.com/zloirock/core-js"
});
var Zl = zs.exports, rv = va, ev = Object, tv = function(r) {
  return ev(rv(r));
}, nv = lr, av = tv, ov = nv({}.hasOwnProperty), da = Object.hasOwn || function(e, t) {
  return ov(av(e), t);
}, iv = lr, sv = 0, cv = Math.random(), uv = iv(1 .toString), lv = function(r) {
  return "Symbol(" + (r === void 0 ? "" : r) + ")_" + uv(++sv + cv, 36);
}, vv = rr, fv = Zl, uo = da, dv = lv, pv = Vs, $v = Ws, br = vv.Symbol, Et = fv("wks"), hv = $v ? br.for || br : br && br.withoutSetter || dv, re = function(r) {
  return uo(Et, r) || (Et[r] = pv && uo(br, r) ? br[r] : hv("Symbol." + r)), Et[r];
}, yv = la, lo = Zr, vo = Ys, gv = Vl, mv = Yl, bv = re, Sv = TypeError, Ov = bv("toPrimitive"), _v = function(r, e) {
  if (!lo(r) || vo(r)) return r;
  var t = gv(r, Ov), n;
  if (t) {
    if (e === void 0 && (e = "default"), n = yv(t, r, e), !lo(n) || vo(n)) return n;
    throw Sv("Can't convert object to primitive value");
  }
  return e === void 0 && (e = "number"), mv(r, e);
}, Tv = _v, Ev = Ys, qs = function(r) {
  var e = Tv(r, "string");
  return Ev(e) ? e : e + "";
}, wv = rr, fo = Zr, Mn = wv.document, Iv = fo(Mn) && fo(Mn.createElement), Pv = function(r) {
  return Iv ? Mn.createElement(r) : {};
}, Rv = Qr, Cv = Z, Av = Pv, Js = !Rv && !Cv(function() {
  return Object.defineProperty(Av("div"), "a", {
    get: function() {
      return 7;
    }
  }).a !== 7;
}), Dv = Qr, jv = la, xv = ks, Nv = Fs, kv = Us, Mv = qs, Lv = da, Fv = Js, po = Object.getOwnPropertyDescriptor;
Ns.f = Dv ? po : function(e, t) {
  if (e = kv(e), t = Mv(t), Fv) try {
    return po(e, t);
  } catch {
  }
  if (Lv(e, t)) return Nv(!jv(xv.f, e, t), e[t]);
};
var Bv = Z, Uv = er, Kv = /#|\.prototype\./, ee = function(r, e) {
  var t = Vv[Gv(r)];
  return t === Yv ? !0 : t === Wv ? !1 : Uv(e) ? Bv(e) : !!e;
}, Gv = ee.normalize = function(r) {
  return String(r).replace(Kv, ".").toLowerCase();
}, Vv = ee.data = {}, Wv = ee.NATIVE = "N", Yv = ee.POLYFILL = "P", Hv = ee, $o = Ds, zv = Hs, qv = qe, Jv = $o($o.bind), Xv = function(r, e) {
  return zv(r), e === void 0 ? r : qv ? Jv(r, e) : function() {
    return r.apply(e, arguments);
  };
}, Xs = {}, Qv = Qr, Zv = Z, rf = Qv && Zv(function() {
  return Object.defineProperty(function() {
  }, "prototype", {
    value: 42,
    writable: !1
  }).prototype !== 42;
}), ef = Zr, tf = String, nf = TypeError, af = function(r) {
  if (ef(r)) return r;
  throw nf(tf(r) + " is not an object");
}, of = Qr, sf = Js, cf = rf, be = af, ho = qs, uf = TypeError, wt = Object.defineProperty, lf = Object.getOwnPropertyDescriptor, It = "enumerable", Pt = "configurable", Rt = "writable";
Xs.f = of ? cf ? function(e, t, n) {
  if (be(e), t = ho(t), be(n), typeof e == "function" && t === "prototype" && "value" in n && Rt in n && !n[Rt]) {
    var a = lf(e, t);
    a && a[Rt] && (e[t] = n.value, n = {
      configurable: Pt in n ? n[Pt] : a[Pt],
      enumerable: It in n ? n[It] : a[It],
      writable: !1
    });
  }
  return wt(e, t, n);
} : wt : function(e, t, n) {
  if (be(e), t = ho(t), be(n), sf) try {
    return wt(e, t, n);
  } catch {
  }
  if ("get" in n || "set" in n) throw uf("Accessors not supported");
  return "value" in n && (e[t] = n.value), e;
};
var vf = Qr, ff = Xs, df = Fs, pf = vf ? function(r, e, t) {
  return ff.f(r, e, df(1, t));
} : function(r, e, t) {
  return r[e] = t, r;
}, Se = rr, $f = al, hf = Ds, yf = er, gf = Ns.f, mf = Hv, dr = fa, bf = Xv, pr = pf, yo = da, Sf = function(r) {
  var e = function(t, n, a) {
    if (this instanceof e) {
      switch (arguments.length) {
        case 0:
          return new r();
        case 1:
          return new r(t);
        case 2:
          return new r(t, n);
      }
      return new r(t, n, a);
    }
    return $f(r, this, arguments);
  };
  return e.prototype = r.prototype, e;
}, Qs = function(r, e) {
  var t = r.target, n = r.global, a = r.stat, o = r.proto, i = n ? Se : a ? Se[t] : (Se[t] || {}).prototype, s = n ? dr : dr[t] || pr(dr, t, {})[t], l = s.prototype, c, u, v, f, d, p, y, $, b;
  for (f in e)
    c = mf(n ? f : t + (a ? "." : "#") + f, r.forced), u = !c && i && yo(i, f), p = s[f], u && (r.dontCallGetSet ? (b = gf(i, f), y = b && b.value) : y = i[f]), d = u && y ? y : e[f], !(u && typeof p == typeof d) && (r.bind && u ? $ = bf(d, Se) : r.wrap && u ? $ = Sf(d) : o && yf(d) ? $ = hf(d) : $ = d, (r.sham || d && d.sham || p && p.sham) && pr($, "sham", !0), pr(s, f, $), o && (v = t + "Prototype", yo(dr, v) || pr(dr, v, {}), pr(dr[v], f, d), r.real && l && (c || !l[f]) && pr(l, f, d)));
}, Of = Math.ceil, _f = Math.floor, Tf = Math.trunc || function(e) {
  var t = +e;
  return (t > 0 ? _f : Of)(t);
}, Ef = Tf, Zs = function(r) {
  var e = +r;
  return e !== e || e === 0 ? 0 : Ef(e);
}, wf = Zs, If = Math.max, Pf = Math.min, Rf = function(r, e) {
  var t = wf(r);
  return t < 0 ? If(t + e, 0) : Pf(t, e);
}, Cf = Zs, Af = Math.min, Df = function(r) {
  return r > 0 ? Af(Cf(r), 9007199254740991) : 0;
}, jf = Df, xf = function(r) {
  return jf(r.length);
}, Nf = Us, kf = Rf, Mf = xf, Lf = function(r) {
  return function(e, t, n) {
    var a = Nf(e), o = Mf(a), i = kf(n, o), s;
    if (t !== t) {
      for (; o > i; )
        if (s = a[i++], s !== s) return !0;
    } else for (; o > i; i++)
      if (a[i] === t) return r;
    return !r;
  };
}, Ff = {
  // `Array.prototype.includes` method
  // https://tc39.es/ecma262/#sec-array.prototype.includes
  includes: Lf(!0)
}, Bf = Qs, Uf = Ff.includes, Kf = Z, Gf = Kf(function() {
  return !Array(1).includes();
});
Bf({ target: "Array", proto: !0, forced: Gf }, {
  includes: function(e) {
    return Uf(this, e, arguments.length > 1 ? arguments[1] : void 0);
  }
});
var Vf = fa, rc = function(r) {
  return Vf[r + "Prototype"];
}, Wf = rc, Yf = Wf("Array").includes, Hf = Zr, zf = Je, qf = re, Jf = qf("match"), Xf = function(r) {
  var e;
  return Hf(r) && ((e = r[Jf]) !== void 0 ? !!e : zf(r) === "RegExp");
}, Qf = Xf, Zf = TypeError, rd = function(r) {
  if (Qf(r))
    throw Zf("The method doesn't accept regular expressions");
  return r;
}, ed = re, td = ed("toStringTag"), ec = {};
ec[td] = "z";
var nd = String(ec) === "[object z]", ad = nd, od = er, ke = Je, id = re, sd = id("toStringTag"), cd = Object, ud = ke(/* @__PURE__ */ function() {
  return arguments;
}()) === "Arguments", ld = function(r, e) {
  try {
    return r[e];
  } catch {
  }
}, vd = ad ? ke : function(r) {
  var e, t, n;
  return r === void 0 ? "Undefined" : r === null ? "Null" : typeof (t = ld(e = cd(r), sd)) == "string" ? t : ud ? ke(e) : (n = ke(e)) === "Object" && od(e.callee) ? "Arguments" : n;
}, fd = vd, dd = String, pd = function(r) {
  if (fd(r) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
  return dd(r);
}, $d = re, hd = $d("match"), yd = function(r) {
  var e = /./;
  try {
    "/./"[r](e);
  } catch {
    try {
      return e[hd] = !1, "/./"[r](e);
    } catch {
    }
  }
  return !1;
}, gd = Qs, md = lr, bd = rd, Sd = va, go = pd, Od = yd, _d = md("".indexOf);
gd({ target: "String", proto: !0, forced: !Od("includes") }, {
  includes: function(e) {
    return !!~_d(
      go(Sd(this)),
      go(bd(e)),
      arguments.length > 1 ? arguments[1] : void 0
    );
  }
});
var Td = rc, Ed = Td("String").includes, mo = Rs, wd = Yf, Id = Ed, Ct = Array.prototype, At = String.prototype, Pd = function(r) {
  var e = r.includes;
  return r === Ct || mo(Ct, r) && e === Ct.includes ? wd : typeof r == "string" || r === At || mo(At, r) && e === At.includes ? Id : e;
}, Rd = Pd, Cd = Rd, Ad = Cd, Br = /* @__PURE__ */ Zu(Ad);
function bo(r) {
  r = r.replace(/[[]/, "\\[").replace(/[\]]/, "\\]");
  const t = new RegExp(`[\\?&]${r}=([^&#]*)`).exec(location.search);
  return t === null ? null : Dd(t[1].replace(/\+/g, " "));
}
function Dd(r) {
  try {
    return decodeURIComponent(r);
  } catch {
    return console.warn(`Failed to decode param value '${r}'`), r;
  }
}
function jd() {
  const r = bo("staging") || bo("backend-domain");
  if (r) {
    const e = /^\d+$/.test(r) ? `euw1.stag${r === "1" ? "" : r}.dixa.io` : r;
    return sessionStorage.setItem("dixa:backend-domain", e), e;
  }
  return null;
}
var So, Oo, _o, Dt, jt, xt, Nt, kt, Mt, Lt, Ft;
const or = {
  restApiUrl: "_dixa-rest-api-url",
  partnerIntegrationsApiUrl: "_dixa-partner-integrations-api-url",
  filesApiUrl: "_dixa-files-api-url",
  loginUrl: "_dixa-login-url",
  signUpUrl: "_dixa-sign-up-url",
  subdomain: "_dixa-subdomain",
  webSocketUrl: "_dixa-websocket-url"
}, xd = {
  backendDomain: "dixa:backend-domain"
}, Bt = window.location.origin.replace(/^https?:\/\//, ""), h = (Dt = jd()) !== null && Dt !== void 0 ? Dt : sessionStorage.getItem(xd.backendDomain), m = {
  // The development domains.
  develop: ["localhost:8080", "dixadev.com", "dixa.io"],
  // The testing domains.
  test: {
    // The security testing domains.
    security: ["dixa-security.com", "dixa-security.net"],
    // The automation testing domains.
    automation: ["localhost:9999", "test-agent-interface.dixa.io", "test.dixatest.com", "okta-test-org.dixatest.com"]
  },
  // The custom subdomains.
  custom: ["thehaddaway.dixa.com", "demo.dixa.com", "developer.dixa.com", "okta-test.dixa.com", "development.dixa.com", "engineering.dixa.com"],
  default: {
    email: "dixa.com",
    emailIntegration: "email.dixa.io",
    integrations: "docs.dixa.io",
    service: "dixa.io",
    status: "status.dixa.io",
    subdomain: (jt = localStorage.getItem(or.subdomain)) !== null && jt !== void 0 ? jt : "demo",
    userContent: "dixausercontent.com",
    web: "dixa.com",
    accounts: "accounts.dixa.com",
    knowledge: "knowledge-backend-cdn"
  }
}, Nd = {
  assets: `https://assets.${m.default.service}`,
  toolkit: `https://toolkit.${m.default.service}`,
  widget: `https://widget.${m.default.service}`,
  rest: (xt = localStorage.getItem(or.restApiUrl)) !== null && xt !== void 0 ? xt : `https://api.${h ?? m.default.service}`,
  partnerIntegrations: (Nt = localStorage.getItem(or.partnerIntegrationsApiUrl)) !== null && Nt !== void 0 ? Nt : `https://partner-integrations.${h ?? m.default.service}`,
  files: (kt = localStorage.getItem(or.filesApiUrl)) !== null && kt !== void 0 ? kt : `https://files.${h ?? m.default.service}`,
  webSocket: (Mt = localStorage.getItem(or.webSocketUrl)) !== null && Mt !== void 0 ? Mt : `wss://agent-sockets.${h ?? m.default.service}/v2/agent/`,
  userContent: h ? `https://raw.${h.replace(m.default.service, m.default.userContent)}` : `https://raw.${m.default.userContent}`,
  signUp: (Lt = localStorage.getItem(or.signUpUrl)) !== null && Lt !== void 0 ? Lt : `https://${m.default.accounts}/signup`,
  logIn: (Ft = localStorage.getItem(or.loginUrl)) !== null && Ft !== void 0 ? Ft : `https://${m.default.accounts}/signin`,
  smartConversationReply: Ln(h) === "prod" ? `https://knowledge-backend-cdn.${m.default.service}` : `https://knowledge-backend-cdn.stag.${m.default.service}`,
  dixaKnowledgeBackend: Ln(h) === "prod" ? `https://knowledge-backend.${m.default.service}` : `https://knowledge-backend.stag.${m.default.service}`
}, kd = {
  amplitude: {
    environment: Br(So = [...m.test.automation, ...m.develop, ...m.test.security, ...m.custom]).call(So, Bt) || h != null && Br(h).call(h, ".stag") || h != null && Br(h).call(h, ".dev") ? "stag" : "prod"
  },
  launchDarkly: Br(Oo = m.develop).call(Oo, Bt) ? "5ccbf1bfa9046808225e3998" : "5ccbf1bfa9046808225e3999",
  stripe: Br(_o = m.develop).call(_o, Bt) ? "pk_test_jNReMBzv4cyXIBkSUrqaFtd0" : "pk_live_0b40LYRePjPZTtN9E9NbKixl",
  elevio: "599d54aacd7bd",
  birdeatsbug: "eee2fdfc-e7ee-4698-95fd-20e8cb83a4d5",
  jabra: {
    partnerKey: "4d2f-9cba7bbd-a9dd-4703-9847-c70a7df516ba",
    appId: "Dixa",
    appName: "Dixa"
  }
};
function Ln(r) {
  const e = r?.match(/(dev|stag\d?)/);
  return !e || e.length < 2 ? "prod" : e[1];
}
const Yr = {
  environment: Ln(h),
  domain: m.default,
  sdk: kd,
  url: Nd,
  backendDomain: h
};
var Ut = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function Md(r) {
  return r && r.__esModule && Object.prototype.hasOwnProperty.call(r, "default") ? r.default : r;
}
var Oe = function(r) {
  return r && r.Math === Math && r;
}, T = (
  // eslint-disable-next-line es/no-global-this -- safe
  Oe(typeof globalThis == "object" && globalThis) || Oe(typeof window == "object" && window) || // eslint-disable-next-line no-restricted-globals -- safe
  Oe(typeof self == "object" && self) || Oe(typeof Ut == "object" && Ut) || // eslint-disable-next-line no-new-func -- fallback
  /* @__PURE__ */ function() {
    return this;
  }() || Ut || Function("return this")()
), S = function(r) {
  try {
    return !!r();
  } catch {
    return !0;
  }
}, Ld = S, Xe = !Ld(function() {
  var r = (function() {
  }).bind();
  return typeof r != "function" || r.hasOwnProperty("prototype");
}), Fd = Xe, tc = Function.prototype, To = tc.apply, Eo = tc.call, pa = typeof Reflect == "object" && Reflect.apply || (Fd ? Eo.bind(To) : function() {
  return Eo.apply(To, arguments);
}), nc = Xe, ac = Function.prototype, Fn = ac.call, Bd = nc && ac.bind.bind(Fn, Fn), E = nc ? Bd : function(r) {
  return function() {
    return Fn.apply(r, arguments);
  };
}, oc = E, Ud = oc({}.toString), Kd = oc("".slice), vr = function(r) {
  return Kd(Ud(r), 8, -1);
}, Gd = vr, Vd = E, $a = function(r) {
  if (Gd(r) === "Function") return Vd(r);
}, Bn = typeof document == "object" && document.all, Wd = typeof Bn > "u" && Bn !== void 0, ic = {
  all: Bn,
  IS_HTMLDDA: Wd
}, sc = ic, Yd = sc.all, _ = sc.IS_HTMLDDA ? function(r) {
  return typeof r == "function" || r === Yd;
} : function(r) {
  return typeof r == "function";
}, Dr = {}, Hd = S, x = !Hd(function() {
  return Object.defineProperty({}, 1, { get: function() {
    return 7;
  } })[1] !== 7;
}), zd = Xe, _e = Function.prototype.call, R = zd ? _e.bind(_e) : function() {
  return _e.apply(_e, arguments);
}, Qe = {}, cc = {}.propertyIsEnumerable, uc = Object.getOwnPropertyDescriptor, qd = uc && !cc.call({ 1: 2 }, 1);
Qe.f = qd ? function(e) {
  var t = uc(this, e);
  return !!t && t.enumerable;
} : cc;
var fr = function(r, e) {
  return {
    enumerable: !(r & 1),
    configurable: !(r & 2),
    writable: !(r & 4),
    value: e
  };
}, Jd = E, Xd = S, Qd = vr, Kt = Object, Zd = Jd("".split), ha = Xd(function() {
  return !Kt("z").propertyIsEnumerable(0);
}) ? function(r) {
  return Qd(r) === "String" ? Zd(r, "") : Kt(r);
} : Kt, Ze = function(r) {
  return r == null;
}, rp = Ze, ep = TypeError, ya = function(r) {
  if (rp(r)) throw ep("Can't call method on " + r);
  return r;
}, tp = ha, np = ya, q = function(r) {
  return tp(np(r));
}, wo = _, lc = ic, ap = lc.all, N = lc.IS_HTMLDDA ? function(r) {
  return typeof r == "object" ? r !== null : wo(r) || r === ap;
} : function(r) {
  return typeof r == "object" ? r !== null : wo(r);
}, k = {}, Gt = k, Vt = T, op = _, Io = function(r) {
  return op(r) ? r : void 0;
}, M = function(r, e) {
  return arguments.length < 2 ? Io(Gt[r]) || Io(Vt[r]) : Gt[r] && Gt[r][e] || Vt[r] && Vt[r][e];
}, ip = E, te = ip({}.isPrototypeOf), rt = typeof navigator < "u" && String(navigator.userAgent) || "", vc = T, Wt = rt, Po = vc.process, Ro = vc.Deno, Co = Po && Po.versions || Ro && Ro.version, Ao = Co && Co.v8, F, Ge;
Ao && (F = Ao.split("."), Ge = F[0] > 0 && F[0] < 4 ? 1 : +(F[0] + F[1]));
!Ge && Wt && (F = Wt.match(/Edge\/(\d+)/), (!F || F[1] >= 74) && (F = Wt.match(/Chrome\/(\d+)/), F && (Ge = +F[1])));
var et = Ge, Do = et, sp = S, cp = T, up = cp.String, jr = !!Object.getOwnPropertySymbols && !sp(function() {
  var r = Symbol("symbol detection");
  return !up(r) || !(Object(r) instanceof Symbol) || // Chrome 38-40 symbols are not inherited from DOM collections prototypes to instances
  !Symbol.sham && Do && Do < 41;
}), lp = jr, fc = lp && !Symbol.sham && typeof Symbol.iterator == "symbol", vp = M, fp = _, dp = te, pp = fc, $p = Object, tt = pp ? function(r) {
  return typeof r == "symbol";
} : function(r) {
  var e = vp("Symbol");
  return fp(e) && dp(e.prototype, $p(r));
}, hp = String, ne = function(r) {
  try {
    return hp(r);
  } catch {
    return "Object";
  }
}, yp = _, gp = ne, mp = TypeError, V = function(r) {
  if (yp(r)) return r;
  throw mp(gp(r) + " is not a function");
}, bp = V, Sp = Ze, ga = function(r, e) {
  var t = r[e];
  return Sp(t) ? void 0 : bp(t);
}, Yt = R, Ht = _, zt = N, Op = TypeError, _p = function(r, e) {
  var t, n;
  if (e === "string" && Ht(t = r.toString) && !zt(n = Yt(t, r)) || Ht(t = r.valueOf) && !zt(n = Yt(t, r)) || e !== "string" && Ht(t = r.toString) && !zt(n = Yt(t, r))) return n;
  throw Op("Can't convert object to primitive value");
}, dc = { exports: {} }, Tp = !0, jo = T, Ep = Object.defineProperty, wp = function(r, e) {
  try {
    Ep(jo, r, { value: e, configurable: !0, writable: !0 });
  } catch {
    jo[r] = e;
  }
  return e;
}, Ip = T, Pp = wp, xo = "__core-js_shared__", Rp = Ip[xo] || Pp(xo, {}), ma = Rp, No = ma;
(dc.exports = function(r, e) {
  return No[r] || (No[r] = e !== void 0 ? e : {});
})("versions", []).push({
  version: "3.32.1",
  mode: "pure",
  copyright: "© 2014-2023 Denis Pushkarev (zloirock.ru)",
  license: "https://github.com/zloirock/core-js/blob/v3.32.1/LICENSE",
  source: "https://github.com/zloirock/core-js"
});
var ae = dc.exports, Cp = ya, Ap = Object, xr = function(r) {
  return Ap(Cp(r));
}, Dp = E, jp = xr, xp = Dp({}.hasOwnProperty), A = Object.hasOwn || function(e, t) {
  return xp(jp(e), t);
}, Np = E, kp = 0, Mp = Math.random(), Lp = Np(1 .toString), ba = function(r) {
  return "Symbol(" + (r === void 0 ? "" : r) + ")_" + Lp(++kp + Mp, 36);
}, Fp = T, Bp = ae, ko = A, Up = ba, Kp = jr, Gp = fc, Sr = Fp.Symbol, qt = Bp("wks"), Vp = Gp ? Sr.for || Sr : Sr && Sr.withoutSetter || Up, O = function(r) {
  return ko(qt, r) || (qt[r] = Kp && ko(Sr, r) ? Sr[r] : Vp("Symbol." + r)), qt[r];
}, Wp = R, Mo = N, Lo = tt, Yp = ga, Hp = _p, zp = O, qp = TypeError, Jp = zp("toPrimitive"), Xp = function(r, e) {
  if (!Mo(r) || Lo(r)) return r;
  var t = Yp(r, Jp), n;
  if (t) {
    if (e === void 0 && (e = "default"), n = Wp(t, r, e), !Mo(n) || Lo(n)) return n;
    throw qp("Can't convert object to primitive value");
  }
  return e === void 0 && (e = "number"), Hp(r, e);
}, Qp = Xp, Zp = tt, nt = function(r) {
  var e = Qp(r, "string");
  return Zp(e) ? e : e + "";
}, r$ = T, Fo = N, Un = r$.document, e$ = Fo(Un) && Fo(Un.createElement), Sa = function(r) {
  return e$ ? Un.createElement(r) : {};
}, t$ = x, n$ = S, a$ = Sa, pc = !t$ && !n$(function() {
  return Object.defineProperty(a$("div"), "a", {
    get: function() {
      return 7;
    }
  }).a !== 7;
}), o$ = x, i$ = R, s$ = Qe, c$ = fr, u$ = q, l$ = nt, v$ = A, f$ = pc, Bo = Object.getOwnPropertyDescriptor;
Dr.f = o$ ? Bo : function(e, t) {
  if (e = u$(e), t = l$(t), f$) try {
    return Bo(e, t);
  } catch {
  }
  if (v$(e, t)) return c$(!i$(s$.f, e, t), e[t]);
};
var d$ = S, p$ = _, $$ = /#|\.prototype\./, oe = function(r, e) {
  var t = y$[h$(r)];
  return t === m$ ? !0 : t === g$ ? !1 : p$(e) ? d$(e) : !!e;
}, h$ = oe.normalize = function(r) {
  return String(r).replace($$, ".").toLowerCase();
}, y$ = oe.data = {}, g$ = oe.NATIVE = "N", m$ = oe.POLYFILL = "P", $c = oe, Uo = $a, b$ = V, S$ = Xe, O$ = Uo(Uo.bind), ie = function(r, e) {
  return b$(r), e === void 0 ? r : S$ ? O$(r, e) : function() {
    return r.apply(e, arguments);
  };
}, U = {}, _$ = x, T$ = S, hc = _$ && T$(function() {
  return Object.defineProperty(function() {
  }, "prototype", {
    value: 42,
    writable: !1
  }).prototype !== 42;
}), E$ = N, w$ = String, I$ = TypeError, K = function(r) {
  if (E$(r)) return r;
  throw I$(w$(r) + " is not an object");
}, P$ = x, R$ = pc, C$ = hc, Te = K, Ko = nt, A$ = TypeError, Jt = Object.defineProperty, D$ = Object.getOwnPropertyDescriptor, Xt = "enumerable", Qt = "configurable", Zt = "writable";
U.f = P$ ? C$ ? function(e, t, n) {
  if (Te(e), t = Ko(t), Te(n), typeof e == "function" && t === "prototype" && "value" in n && Zt in n && !n[Zt]) {
    var a = D$(e, t);
    a && a[Zt] && (e[t] = n.value, n = {
      configurable: Qt in n ? n[Qt] : a[Qt],
      enumerable: Xt in n ? n[Xt] : a[Xt],
      writable: !1
    });
  }
  return Jt(e, t, n);
} : Jt : function(e, t, n) {
  if (Te(e), t = Ko(t), Te(n), R$) try {
    return Jt(e, t, n);
  } catch {
  }
  if ("get" in n || "set" in n) throw A$("Accessors not supported");
  return "value" in n && (e[t] = n.value), e;
};
var j$ = x, x$ = U, N$ = fr, tr = j$ ? function(r, e, t) {
  return x$.f(r, e, N$(1, t));
} : function(r, e, t) {
  return r[e] = t, r;
}, Ee = T, k$ = pa, M$ = $a, L$ = _, F$ = Dr.f, B$ = $c, $r = k, U$ = ie, hr = tr, Go = A, K$ = function(r) {
  var e = function(t, n, a) {
    if (this instanceof e) {
      switch (arguments.length) {
        case 0:
          return new r();
        case 1:
          return new r(t);
        case 2:
          return new r(t, n);
      }
      return new r(t, n, a);
    }
    return k$(r, this, arguments);
  };
  return e.prototype = r.prototype, e;
}, g = function(r, e) {
  var t = r.target, n = r.global, a = r.stat, o = r.proto, i = n ? Ee : a ? Ee[t] : (Ee[t] || {}).prototype, s = n ? $r : $r[t] || hr($r, t, {})[t], l = s.prototype, c, u, v, f, d, p, y, $, b;
  for (f in e)
    c = B$(n ? f : t + (a ? "." : "#") + f, r.forced), u = !c && i && Go(i, f), p = s[f], u && (r.dontCallGetSet ? (b = F$(i, f), y = b && b.value) : y = i[f]), d = u && y ? y : e[f], !(u && typeof p == typeof d) && (r.bind && u ? $ = U$(d, Ee) : r.wrap && u ? $ = K$(d) : o && L$(d) ? $ = M$(d) : $ = d, (r.sham || d && d.sham || p && p.sham) && hr($, "sham", !0), hr(s, f, $), o && (v = t + "Prototype", Go($r, v) || hr($r, v, {}), hr($r[v], f, d), r.real && l && (c || !l[f]) && hr(l, f, d)));
}, G$ = E, V$ = V, W$ = function(r, e, t) {
  try {
    return G$(V$(Object.getOwnPropertyDescriptor(r, e)[t]));
  } catch {
  }
}, Y$ = _, H$ = String, z$ = TypeError, q$ = function(r) {
  if (typeof r == "object" || Y$(r)) return r;
  throw z$("Can't set " + H$(r) + " as a prototype");
}, J$ = W$, X$ = K, Q$ = q$, yc = Object.setPrototypeOf || ("__proto__" in {} ? function() {
  var r = !1, e = {}, t;
  try {
    t = J$(Object.prototype, "__proto__", "set"), t(e, []), r = e instanceof Array;
  } catch {
  }
  return function(a, o) {
    return X$(a), Q$(o), r ? t(a, o) : a.__proto__ = o, a;
  };
}() : void 0), Z$ = g, rh = yc;
Z$({ target: "Object", stat: !0 }, {
  setPrototypeOf: rh
});
var eh = k;
eh.Object.setPrototypeOf;
var Oa = {}, th = Math.ceil, nh = Math.floor, ah = Math.trunc || function(e) {
  var t = +e;
  return (t > 0 ? nh : th)(t);
}, oh = ah, _a = function(r) {
  var e = +r;
  return e !== e || e === 0 ? 0 : oh(e);
}, ih = _a, sh = Math.max, ch = Math.min, Ta = function(r, e) {
  var t = ih(r);
  return t < 0 ? sh(t + e, 0) : ch(t, e);
}, uh = _a, lh = Math.min, vh = function(r) {
  return r > 0 ? lh(uh(r), 9007199254740991) : 0;
}, fh = vh, Nr = function(r) {
  return fh(r.length);
}, dh = q, ph = Ta, $h = Nr, hh = function(r) {
  return function(e, t, n) {
    for (var a = dh(e), o = $h(a), i = ph(n, o); o > i; i++)
      if (i in a && a[i] === t) return i || 0;
    return -1;
  };
}, gc = {
  // `Array.prototype.indexOf` method
  // https://tc39.es/ecma262/#sec-array.prototype.indexof
  indexOf: hh()
}, at = {}, yh = E, rn = A, gh = q, mh = gc.indexOf, bh = at, Vo = yh([].push), mc = function(r, e) {
  var t = gh(r), n = 0, a = [], o;
  for (o in t) !rn(bh, o) && rn(t, o) && Vo(a, o);
  for (; e.length > n; ) rn(t, o = e[n++]) && (~mh(a, o) || Vo(a, o));
  return a;
}, Ea = [
  "constructor",
  "hasOwnProperty",
  "isPrototypeOf",
  "propertyIsEnumerable",
  "toLocaleString",
  "toString",
  "valueOf"
], Sh = mc, Oh = Ea, wa = Object.keys || function(e) {
  return Sh(e, Oh);
}, _h = x, Th = hc, Eh = U, wh = K, Ih = q, Ph = wa;
Oa.f = _h && !Th ? Object.defineProperties : function(e, t) {
  wh(e);
  for (var n = Ih(t), a = Ph(t), o = a.length, i = 0, s; o > i; ) Eh.f(e, s = a[i++], n[s]);
  return e;
};
var Rh = M, bc = Rh("document", "documentElement"), Ch = ae, Ah = ba, Wo = Ch("keys"), ot = function(r) {
  return Wo[r] || (Wo[r] = Ah(r));
}, Dh = K, jh = Oa, Yo = Ea, xh = at, Nh = bc, kh = Sa, Mh = ot, Ho = ">", zo = "<", Kn = "prototype", Gn = "script", Sc = Mh("IE_PROTO"), en = function() {
}, Oc = function(r) {
  return zo + Gn + Ho + r + zo + "/" + Gn + Ho;
}, qo = function(r) {
  r.write(Oc("")), r.close();
  var e = r.parentWindow.Object;
  return r = null, e;
}, Lh = function() {
  var r = kh("iframe"), e = "java" + Gn + ":", t;
  return r.style.display = "none", Nh.appendChild(r), r.src = String(e), t = r.contentWindow.document, t.open(), t.write(Oc("document.F=Object")), t.close(), t.F;
}, we, Me = function() {
  try {
    we = new ActiveXObject("htmlfile");
  } catch {
  }
  Me = typeof document < "u" ? document.domain && we ? qo(we) : Lh() : qo(we);
  for (var r = Yo.length; r--; ) delete Me[Kn][Yo[r]];
  return Me();
};
xh[Sc] = !0;
var se = Object.create || function(e, t) {
  var n;
  return e !== null ? (en[Kn] = Dh(e), n = new en(), en[Kn] = null, n[Sc] = e) : n = Me(), t === void 0 ? n : jh.f(n, t);
}, Fh = g, Bh = x, Uh = se;
Fh({ target: "Object", stat: !0, sham: !Bh }, {
  create: Uh
});
var Kh = k;
Kh.Object;
var ce = {};
ce.f = Object.getOwnPropertySymbols;
var Jo = x, Gh = E, Vh = R, Wh = S, tn = wa, Yh = ce, Hh = Qe, zh = xr, qh = ha, yr = Object.assign, Xo = Object.defineProperty, Jh = Gh([].concat), Xh = !yr || Wh(function() {
  if (Jo && yr({ b: 1 }, yr(Xo({}, "a", {
    enumerable: !0,
    get: function() {
      Xo(this, "b", {
        value: 3,
        enumerable: !1
      });
    }
  }), { b: 2 })).b !== 1) return !0;
  var r = {}, e = {}, t = Symbol("assign detection"), n = "abcdefghijklmnopqrst";
  return r[t] = 7, n.split("").forEach(function(a) {
    e[a] = a;
  }), yr({}, r)[t] !== 7 || tn(yr({}, e)).join("") !== n;
}) ? function(e, t) {
  for (var n = zh(e), a = arguments.length, o = 1, i = Yh.f, s = Hh.f; a > o; )
    for (var l = qh(arguments[o++]), c = i ? Jh(tn(l), i(l)) : tn(l), u = c.length, v = 0, f; u > v; )
      f = c[v++], (!Jo || Vh(s, l, f)) && (n[f] = l[f]);
  return n;
} : yr, Qh = g, Qo = Xh;
Qh({ target: "Object", stat: !0, forced: Object.assign !== Qo }, {
  assign: Qo
});
var Zh = k;
Zh.Object.assign;
var ry = S, ey = function(r, e) {
  var t = [][r];
  return !!t && ry(function() {
    t.call(null, e || function() {
      return 1;
    }, 1);
  });
}, ty = g, ny = $a, ay = gc.indexOf, oy = ey, Vn = ny([].indexOf), _c = !!Vn && 1 / Vn([1], 1, -0) < 0, iy = _c || !oy("indexOf");
ty({ target: "Array", proto: !0, forced: iy }, {
  indexOf: function(e) {
    var t = arguments.length > 1 ? arguments[1] : void 0;
    return _c ? Vn(this, e, t) || 0 : ay(this, e, t);
  }
});
var sy = k, Ia = function(r) {
  return sy[r + "Prototype"];
}, cy = Ia;
cy("Array").indexOf;
var uy = O, ly = uy("toStringTag"), Tc = {};
Tc[ly] = "z";
var Pa = String(Tc) === "[object z]", vy = Pa, fy = _, Le = vr, dy = O, py = dy("toStringTag"), $y = Object, hy = Le(/* @__PURE__ */ function() {
  return arguments;
}()) === "Arguments", yy = function(r, e) {
  try {
    return r[e];
  } catch {
  }
}, ue = vy ? Le : function(r) {
  var e, t, n;
  return r === void 0 ? "Undefined" : r === null ? "Null" : typeof (t = yy(e = $y(r), py)) == "string" ? t : hy ? Le(e) : (n = Le(e)) === "Object" && fy(e.callee) ? "Arguments" : n;
}, gy = ue, my = String, kr = function(r) {
  if (gy(r) === "Symbol") throw TypeError("Cannot convert a Symbol value to a string");
  return my(r);
}, it = {}, by = mc, Sy = Ea, Oy = Sy.concat("length", "prototype");
it.f = Object.getOwnPropertyNames || function(e) {
  return by(e, Oy);
};
var Ec = {}, _y = nt, Ty = U, Ey = fr, Ra = function(r, e, t) {
  var n = _y(e);
  n in r ? Ty.f(r, n, Ey(0, t)) : r[n] = t;
}, Zo = Ta, wy = Nr, Iy = Ra, Py = Array, Ry = Math.max, Cy = function(r, e, t) {
  for (var n = wy(r), a = Zo(e, n), o = Zo(t === void 0 ? n : t, n), i = Py(Ry(o - a, 0)), s = 0; a < o; a++, s++) Iy(i, s, r[a]);
  return i.length = s, i;
}, Ay = vr, Dy = q, wc = it.f, jy = Cy, Ic = typeof window == "object" && window && Object.getOwnPropertyNames ? Object.getOwnPropertyNames(window) : [], xy = function(r) {
  try {
    return wc(r);
  } catch {
    return jy(Ic);
  }
};
Ec.f = function(e) {
  return Ic && Ay(e) === "Window" ? xy(e) : wc(Dy(e));
};
var Ny = tr, le = function(r, e, t, n) {
  return n && n.enumerable ? r[e] = t : Ny(r, e, t), r;
}, ky = U, Pc = function(r, e, t) {
  return ky.f(r, e, t);
}, ve = {}, My = O;
ve.f = My;
var ri = k, Ly = A, Fy = ve, By = U.f, D = function(r) {
  var e = ri.Symbol || (ri.Symbol = {});
  Ly(e, r) || By(e, r, {
    value: Fy.f(r)
  });
}, Uy = R, Ky = M, Gy = O, Vy = le, Rc = function() {
  var r = Ky("Symbol"), e = r && r.prototype, t = e && e.valueOf, n = Gy("toPrimitive");
  e && !e[n] && Vy(e, n, function(a) {
    return Uy(t, this);
  }, {});
}, Wy = Pa, Yy = ue, Hy = Wy ? {}.toString : function() {
  return "[object " + Yy(this) + "]";
}, zy = Pa, qy = U.f, Jy = tr, Xy = A, Qy = Hy, Zy = O, ei = Zy("toStringTag"), Mr = function(r, e, t, n) {
  if (r) {
    var a = t ? r : r.prototype;
    Xy(a, ei) || qy(a, ei, { configurable: !0, value: e }), n && !zy && Jy(a, "toString", Qy);
  }
}, rg = T, eg = _, ti = rg.WeakMap, tg = eg(ti) && /native code/.test(String(ti)), ng = tg, Cc = T, ag = N, og = tr, nn = A, an = ma, ig = ot, sg = at, ni = "Object already initialized", Wn = Cc.TypeError, cg = Cc.WeakMap, Ve, Hr, We, ug = function(r) {
  return We(r) ? Hr(r) : Ve(r, {});
}, lg = function(r) {
  return function(e) {
    var t;
    if (!ag(e) || (t = Hr(e)).type !== r)
      throw Wn("Incompatible receiver, " + r + " required");
    return t;
  };
};
if (ng || an.state) {
  var G = an.state || (an.state = new cg());
  G.get = G.get, G.has = G.has, G.set = G.set, Ve = function(r, e) {
    if (G.has(r)) throw Wn(ni);
    return e.facade = r, G.set(r, e), e;
  }, Hr = function(r) {
    return G.get(r) || {};
  }, We = function(r) {
    return G.has(r);
  };
} else {
  var gr = ig("state");
  sg[gr] = !0, Ve = function(r, e) {
    if (nn(r, gr)) throw Wn(ni);
    return e.facade = r, og(r, gr, e), e;
  }, Hr = function(r) {
    return nn(r, gr) ? r[gr] : {};
  }, We = function(r) {
    return nn(r, gr);
  };
}
var st = {
  set: Ve,
  get: Hr,
  has: We,
  enforce: ug,
  getterFor: lg
}, vg = vr, ct = Array.isArray || function(e) {
  return vg(e) === "Array";
}, fg = E, dg = _, Yn = ma, pg = fg(Function.toString);
dg(Yn.inspectSource) || (Yn.inspectSource = function(r) {
  return pg(r);
});
var Ac = Yn.inspectSource, $g = E, hg = S, Dc = _, yg = ue, gg = M, mg = Ac, jc = function() {
}, bg = [], xc = gg("Reflect", "construct"), Ca = /^\s*(?:class|function)\b/, Sg = $g(Ca.exec), Og = !Ca.exec(jc), Ur = function(e) {
  if (!Dc(e)) return !1;
  try {
    return xc(jc, bg, e), !0;
  } catch {
    return !1;
  }
}, Nc = function(e) {
  if (!Dc(e)) return !1;
  switch (yg(e)) {
    case "AsyncFunction":
    case "GeneratorFunction":
    case "AsyncGeneratorFunction":
      return !1;
  }
  try {
    return Og || !!Sg(Ca, mg(e));
  } catch {
    return !0;
  }
};
Nc.sham = !0;
var Aa = !xc || hg(function() {
  var r;
  return Ur(Ur.call) || !Ur(Object) || !Ur(function() {
    r = !0;
  }) || r;
}) ? Nc : Ur, ai = ct, _g = Aa, Tg = N, Eg = O, wg = Eg("species"), oi = Array, Ig = function(r) {
  var e;
  return ai(r) && (e = r.constructor, _g(e) && (e === oi || ai(e.prototype)) ? e = void 0 : Tg(e) && (e = e[wg], e === null && (e = void 0))), e === void 0 ? oi : e;
}, Pg = Ig, Rg = function(r, e) {
  return new (Pg(r))(e === 0 ? 0 : e);
}, Cg = ie, Ag = E, Dg = ha, jg = xr, xg = Nr;
Ag([].push);
var Ng = function(r) {
  return function(e, t, n, a) {
    for (var o = jg(e), i = Dg(o), s = Cg(t, n), l = xg(i), c = 0, u = void 0, v; l > c; c++) c in i && (v = i[c], s(v, c, o));
    return u;
  };
}, kg = {
  // `Array.prototype.forEach` method
  // https://tc39.es/ecma262/#sec-array.prototype.foreach
  forEach: Ng()
}, ut = g, Da = T, ja = R, Mg = E, Ir = x, Pr = jr, Lg = S, w = A, Fg = te, Hn = K, lt = q, xa = nt, Bg = kr, zn = fr, zr = se, kc = wa, Ug = it, Mc = Ec, Kg = ce, Lc = Dr, Fc = U, Gg = Oa, Bc = Qe, ii = le, Vg = Pc, Na = ae, Wg = ot, Uc = at, si = ba, Yg = O, Hg = ve, zg = D, qg = Rc, Jg = Mr, Kc = st, vt = kg.forEach, C = Wg("hidden"), ft = "Symbol", qr = "prototype", Xg = Kc.set, ci = Kc.getterFor(ft), B = Object[qr], cr = Da.Symbol, Kr = cr && cr[qr], Qg = Da.TypeError, on = Da.QObject, Gc = Lc.f, sr = Fc.f, Vc = Mc.f, Zg = Bc.f, Wc = Mg([].push), H = Na("symbols"), fe = Na("op-symbols"), rm = Na("wks"), qn = !on || !on[qr] || !on[qr].findChild, Jn = Ir && Lg(function() {
  return zr(sr({}, "a", {
    get: function() {
      return sr(this, "a", { value: 7 }).a;
    }
  })).a !== 7;
}) ? function(r, e, t) {
  var n = Gc(B, e);
  n && delete B[e], sr(r, e, t), n && r !== B && sr(B, e, n);
} : sr, sn = function(r, e) {
  var t = H[r] = zr(Kr);
  return Xg(t, {
    type: ft,
    tag: r,
    description: e
  }), Ir || (t.description = e), t;
}, dt = function(e, t, n) {
  e === B && dt(fe, t, n), Hn(e);
  var a = xa(t);
  return Hn(n), w(H, a) ? (n.enumerable ? (w(e, C) && e[C][a] && (e[C][a] = !1), n = zr(n, { enumerable: zn(0, !1) })) : (w(e, C) || sr(e, C, zn(1, {})), e[C][a] = !0), Jn(e, a, n)) : sr(e, a, n);
}, ka = function(e, t) {
  Hn(e);
  var n = lt(t), a = kc(n).concat(qc(n));
  return vt(a, function(o) {
    (!Ir || ja(Yc, n, o)) && dt(e, o, n[o]);
  }), e;
}, em = function(e, t) {
  return t === void 0 ? zr(e) : ka(zr(e), t);
}, Yc = function(e) {
  var t = xa(e), n = ja(Zg, this, t);
  return this === B && w(H, t) && !w(fe, t) ? !1 : n || !w(this, t) || !w(H, t) || w(this, C) && this[C][t] ? n : !0;
}, Hc = function(e, t) {
  var n = lt(e), a = xa(t);
  if (!(n === B && w(H, a) && !w(fe, a))) {
    var o = Gc(n, a);
    return o && w(H, a) && !(w(n, C) && n[C][a]) && (o.enumerable = !0), o;
  }
}, zc = function(e) {
  var t = Vc(lt(e)), n = [];
  return vt(t, function(a) {
    !w(H, a) && !w(Uc, a) && Wc(n, a);
  }), n;
}, qc = function(r) {
  var e = r === B, t = Vc(e ? fe : lt(r)), n = [];
  return vt(t, function(a) {
    w(H, a) && (!e || w(B, a)) && Wc(n, H[a]);
  }), n;
};
Pr || (cr = function() {
  if (Fg(Kr, this)) throw Qg("Symbol is not a constructor");
  var e = !arguments.length || arguments[0] === void 0 ? void 0 : Bg(arguments[0]), t = si(e), n = function(a) {
    this === B && ja(n, fe, a), w(this, C) && w(this[C], t) && (this[C][t] = !1), Jn(this, t, zn(1, a));
  };
  return Ir && qn && Jn(B, t, { configurable: !0, set: n }), sn(t, e);
}, Kr = cr[qr], ii(Kr, "toString", function() {
  return ci(this).tag;
}), ii(cr, "withoutSetter", function(r) {
  return sn(si(r), r);
}), Bc.f = Yc, Fc.f = dt, Gg.f = ka, Lc.f = Hc, Ug.f = Mc.f = zc, Kg.f = qc, Hg.f = function(r) {
  return sn(Yg(r), r);
}, Ir && Vg(Kr, "description", {
  configurable: !0,
  get: function() {
    return ci(this).description;
  }
}));
ut({ global: !0, wrap: !0, forced: !Pr, sham: !Pr }, {
  Symbol: cr
});
vt(kc(rm), function(r) {
  zg(r);
});
ut({ target: ft, stat: !0, forced: !Pr }, {
  useSetter: function() {
    qn = !0;
  },
  useSimple: function() {
    qn = !1;
  }
});
ut({ target: "Object", stat: !0, forced: !Pr, sham: !Ir }, {
  // `Object.create` method
  // https://tc39.es/ecma262/#sec-object.create
  create: em,
  // `Object.defineProperty` method
  // https://tc39.es/ecma262/#sec-object.defineproperty
  defineProperty: dt,
  // `Object.defineProperties` method
  // https://tc39.es/ecma262/#sec-object.defineproperties
  defineProperties: ka,
  // `Object.getOwnPropertyDescriptor` method
  // https://tc39.es/ecma262/#sec-object.getownpropertydescriptors
  getOwnPropertyDescriptor: Hc
});
ut({ target: "Object", stat: !0, forced: !Pr }, {
  // `Object.getOwnPropertyNames` method
  // https://tc39.es/ecma262/#sec-object.getownpropertynames
  getOwnPropertyNames: zc
});
qg();
Jg(cr, ft);
Uc[C] = !0;
var tm = jr, Jc = tm && !!Symbol.for && !!Symbol.keyFor, nm = g, am = M, om = A, im = kr, Xc = ae, sm = Jc, cn = Xc("string-to-symbol-registry"), cm = Xc("symbol-to-string-registry");
nm({ target: "Symbol", stat: !0, forced: !sm }, {
  for: function(r) {
    var e = im(r);
    if (om(cn, e)) return cn[e];
    var t = am("Symbol")(e);
    return cn[e] = t, cm[t] = e, t;
  }
});
var um = g, lm = A, vm = tt, fm = ne, dm = ae, pm = Jc, ui = dm("symbol-to-string-registry");
um({ target: "Symbol", stat: !0, forced: !pm }, {
  keyFor: function(e) {
    if (!vm(e)) throw TypeError(fm(e) + " is not a symbol");
    if (lm(ui, e)) return ui[e];
  }
});
var $m = E, Ma = $m([].slice), hm = E, li = ct, ym = _, vi = vr, gm = kr, fi = hm([].push), mm = function(r) {
  if (ym(r)) return r;
  if (li(r)) {
    for (var e = r.length, t = [], n = 0; n < e; n++) {
      var a = r[n];
      typeof a == "string" ? fi(t, a) : (typeof a == "number" || vi(a) === "Number" || vi(a) === "String") && fi(t, gm(a));
    }
    var o = t.length, i = !0;
    return function(s, l) {
      if (i)
        return i = !1, l;
      if (li(this)) return l;
      for (var c = 0; c < o; c++) if (t[c] === s) return l;
    };
  }
}, bm = g, Qc = M, Zc = pa, Sm = R, de = E, ru = S, di = _, pi = tt, eu = Ma, Om = mm, _m = jr, Tm = String, X = Qc("JSON", "stringify"), Ie = de(/./.exec), $i = de("".charAt), Em = de("".charCodeAt), wm = de("".replace), Im = de(1 .toString), Pm = /[\uD800-\uDFFF]/g, hi = /^[\uD800-\uDBFF]$/, yi = /^[\uDC00-\uDFFF]$/, gi = !_m || ru(function() {
  var r = Qc("Symbol")("stringify detection");
  return X([r]) !== "[null]" || X({ a: r }) !== "{}" || X(Object(r)) !== "{}";
}), mi = ru(function() {
  return X("\uDF06\uD834") !== '"\\udf06\\ud834"' || X("\uDEAD") !== '"\\udead"';
}), Rm = function(r, e) {
  var t = eu(arguments), n = Om(e);
  if (!(!di(n) && (r === void 0 || pi(r))))
    return t[1] = function(a, o) {
      if (di(n) && (o = Sm(n, this, Tm(a), o)), !pi(o)) return o;
    }, Zc(X, null, t);
}, Cm = function(r, e, t) {
  var n = $i(t, e - 1), a = $i(t, e + 1);
  return Ie(hi, r) && !Ie(yi, a) || Ie(yi, r) && !Ie(hi, n) ? "\\u" + Im(Em(r, 0), 16) : r;
};
X && bm({ target: "JSON", stat: !0, forced: gi || mi }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  stringify: function(e, t, n) {
    var a = eu(arguments), o = Zc(gi ? Rm : X, null, a);
    return mi && typeof o == "string" ? wm(o, Pm, Cm) : o;
  }
});
var Am = g, Dm = jr, jm = S, tu = ce, xm = xr, Nm = !Dm || jm(function() {
  tu.f(1);
});
Am({ target: "Object", stat: !0, forced: Nm }, {
  getOwnPropertySymbols: function(e) {
    var t = tu.f;
    return t ? t(xm(e)) : [];
  }
});
var km = k;
km.Object.getOwnPropertySymbols;
var Mm = g, Lm = S, Fm = q, nu = Dr.f, au = x, Bm = !au || Lm(function() {
  nu(1);
});
Mm({ target: "Object", stat: !0, forced: Bm, sham: !au }, {
  getOwnPropertyDescriptor: function(e, t) {
    return nu(Fm(e), t);
  }
});
var Um = k, Km = Um.Object;
Km.getOwnPropertyDescriptor.sham;
var Gm = g, Vm = x, bi = U.f;
Gm({ target: "Object", stat: !0, forced: Object.defineProperty !== bi, sham: !Vm }, {
  defineProperty: bi
});
var Wm = k, Ym = Wm.Object;
Ym.defineProperty.sham;
var Hm = S, zm = !Hm(function() {
  function r() {
  }
  return r.prototype.constructor = null, Object.getPrototypeOf(new r()) !== r.prototype;
}), qm = A, Jm = _, Xm = xr, Qm = ot, Zm = zm, Si = Qm("IE_PROTO"), Xn = Object, rb = Xn.prototype, La = Zm ? Xn.getPrototypeOf : function(r) {
  var e = Xm(r);
  if (qm(e, Si)) return e[Si];
  var t = e.constructor;
  return Jm(t) && e instanceof t ? t.prototype : e instanceof Xn ? rb : null;
}, eb = M, tb = E, nb = it, ab = ce, ob = K, ib = tb([].concat), sb = eb("Reflect", "ownKeys") || function(e) {
  var t = nb.f(ob(e)), n = ab.f;
  return n ? ib(t, n(e)) : t;
}, Oi = A, cb = sb, ub = Dr, lb = U, vb = function(r, e, t) {
  for (var n = cb(e), a = lb.f, o = ub.f, i = 0; i < n.length; i++) {
    var s = n[i];
    !Oi(r, s) && !(t && Oi(t, s)) && a(r, s, o(e, s));
  }
}, fb = N, db = tr, pb = function(r, e) {
  fb(e) && "cause" in e && db(r, "cause", e.cause);
}, $b = E, ou = Error, hb = $b("".replace), yb = function(r) {
  return String(ou(r).stack);
}("zxcasd"), iu = /\n\s*at [^:]*:[^\n]*/, gb = iu.test(yb), mb = function(r, e) {
  if (gb && typeof r == "string" && !ou.prepareStackTrace)
    for (; e--; ) r = hb(r, iu, "");
  return r;
}, bb = S, Sb = fr, Ob = !bb(function() {
  var r = Error("a");
  return "stack" in r ? (Object.defineProperty(r, "stack", Sb(1, 7)), r.stack !== 7) : !0;
}), _b = tr, Tb = mb, Eb = Ob, _i = Error.captureStackTrace, wb = function(r, e, t, n) {
  Eb && (_i ? _i(r, e) : _b(r, "stack", Tb(t, n)));
}, Lr = {}, Ib = O, Pb = Lr, Rb = Ib("iterator"), Cb = Array.prototype, Ab = function(r) {
  return r !== void 0 && (Pb.Array === r || Cb[Rb] === r);
}, Db = ue, Ti = ga, jb = Ze, xb = Lr, Nb = O, kb = Nb("iterator"), su = function(r) {
  if (!jb(r)) return Ti(r, kb) || Ti(r, "@@iterator") || xb[Db(r)];
}, Mb = R, Lb = V, Fb = K, Bb = ne, Ub = su, Kb = TypeError, Gb = function(r, e) {
  var t = arguments.length < 2 ? Ub(r) : e;
  if (Lb(t)) return Fb(Mb(t, r));
  throw Kb(Bb(r) + " is not iterable");
}, Vb = R, Ei = K, Wb = ga, Yb = function(r, e, t) {
  var n, a;
  Ei(r);
  try {
    if (n = Wb(r, "return"), !n) {
      if (e === "throw") throw t;
      return t;
    }
    n = Vb(n, r);
  } catch (o) {
    a = !0, n = o;
  }
  if (e === "throw") throw t;
  if (a) throw n;
  return Ei(n), t;
}, Hb = ie, zb = R, qb = K, Jb = ne, Xb = Ab, Qb = Nr, wi = te, Zb = Gb, rS = su, Ii = Yb, eS = TypeError, Fe = function(r, e) {
  this.stopped = r, this.result = e;
}, Pi = Fe.prototype, pe = function(r, e, t) {
  var n = t && t.that, a = !!(t && t.AS_ENTRIES), o = !!(t && t.IS_RECORD), i = !!(t && t.IS_ITERATOR), s = !!(t && t.INTERRUPTED), l = Hb(e, n), c, u, v, f, d, p, y, $ = function(I) {
    return c && Ii(c, "normal", I), new Fe(!0, I);
  }, b = function(I) {
    return a ? (qb(I), s ? l(I[0], I[1], $) : l(I[0], I[1])) : s ? l(I, $) : l(I);
  };
  if (o)
    c = r.iterator;
  else if (i)
    c = r;
  else {
    if (u = rS(r), !u) throw eS(Jb(r) + " is not iterable");
    if (Xb(u)) {
      for (v = 0, f = Qb(r); f > v; v++)
        if (d = b(r[v]), d && wi(Pi, d)) return d;
      return new Fe(!1);
    }
    c = Zb(r, u);
  }
  for (p = o ? r.next : c.next; !(y = zb(p, c)).done; ) {
    try {
      d = b(y.value);
    } catch (I) {
      Ii(c, "throw", I);
    }
    if (typeof d == "object" && d && wi(Pi, d)) return d;
  }
  return new Fe(!1);
}, tS = kr, nS = function(r, e) {
  return r === void 0 ? arguments.length < 2 ? "" : e : tS(r);
}, aS = g, oS = te, iS = La, Ye = yc, sS = vb, cu = se, un = tr, ln = fr, cS = pb, uS = wb, lS = pe, vS = nS, fS = O, dS = fS("toStringTag"), He = Error, pS = [].push, Rr = function(e, t) {
  var n = oS(vn, this), a;
  Ye ? a = Ye(He(), n ? iS(this) : vn) : (a = n ? this : cu(vn), un(a, dS, "Error")), t !== void 0 && un(a, "message", vS(t)), uS(a, Rr, a.stack, 1), arguments.length > 2 && cS(a, arguments[2]);
  var o = [];
  return lS(e, pS, { that: o }), un(a, "errors", o), a;
};
Ye ? Ye(Rr, He) : sS(Rr, He, { name: !0 });
var vn = Rr.prototype = cu(He.prototype, {
  constructor: ln(1, Rr),
  message: ln(1, ""),
  name: ln(1, "AggregateError")
});
aS({ global: !0 }, {
  AggregateError: Rr
});
var Qn = x, $S = A, uu = Function.prototype, hS = Qn && Object.getOwnPropertyDescriptor, lu = $S(uu, "name"), yS = lu && (function() {
}).name === "something";
lu && (!Qn || Qn && hS(uu, "name").configurable);
var gS = {
  PROPER: yS
}, mS = S, bS = _, SS = N, OS = se, Ri = La, _S = le, TS = O, Zn = TS("iterator"), vu = !1, Y, fn, dn;
[].keys && (dn = [].keys(), "next" in dn ? (fn = Ri(Ri(dn)), fn !== Object.prototype && (Y = fn)) : vu = !0);
var ES = !SS(Y) || mS(function() {
  var r = {};
  return Y[Zn].call(r) !== r;
});
ES ? Y = {} : Y = OS(Y);
bS(Y[Zn]) || _S(Y, Zn, function() {
  return this;
});
var fu = {
  IteratorPrototype: Y,
  BUGGY_SAFARI_ITERATORS: vu
}, wS = fu.IteratorPrototype, IS = se, PS = fr, RS = Mr, CS = Lr, AS = function() {
  return this;
}, DS = function(r, e, t, n) {
  var a = e + " Iterator";
  return r.prototype = IS(wS, { next: PS(+!n, t) }), RS(r, a, !1, !0), CS[a] = AS, r;
}, jS = g, xS = R, NS = gS, kS = DS, MS = La, LS = Mr, Ci = le, FS = O, Ai = Lr, BS = fu, US = NS.PROPER, Pe = BS.BUGGY_SAFARI_ITERATORS, pn = FS("iterator"), Di = "keys", Re = "values", ji = "entries", KS = function() {
  return this;
}, du = function(r, e, t, n, a, o, i) {
  kS(t, e, n);
  var s = function(b) {
    if (b === a && f) return f;
    if (!Pe && b in u) return u[b];
    switch (b) {
      case Di:
        return function() {
          return new t(this, b);
        };
      case Re:
        return function() {
          return new t(this, b);
        };
      case ji:
        return function() {
          return new t(this, b);
        };
    }
    return function() {
      return new t(this);
    };
  }, l = e + " Iterator", c = !1, u = r.prototype, v = u[pn] || u["@@iterator"] || a && u[a], f = !Pe && v || s(a), d = e === "Array" && u.entries || v, p, y, $;
  if (d && (p = MS(d.call(new r())), p !== Object.prototype && p.next && (LS(p, l, !0, !0), Ai[l] = KS)), US && a === Re && v && v.name !== Re && (c = !0, f = function() {
    return xS(v, this);
  }), a)
    if (y = {
      values: s(Re),
      keys: o ? f : s(Di),
      entries: s(ji)
    }, i) for ($ in y)
      (Pe || c || !($ in u)) && Ci(u, $, y[$]);
    else jS({ target: e, proto: !0, forced: Pe || c }, y);
  return i && u[pn] !== f && Ci(u, pn, f, {}), Ai[e] = f, y;
}, pu = function(r, e) {
  return { value: r, done: e };
}, GS = q, xi = Lr, $u = st;
U.f;
var VS = du, Ce = pu, hu = "Array Iterator", WS = $u.set, YS = $u.getterFor(hu);
VS(Array, "Array", function(r, e) {
  WS(this, {
    type: hu,
    target: GS(r),
    // target
    index: 0,
    // next index
    kind: e
    // kind
  });
}, function() {
  var r = YS(this), e = r.target, t = r.kind, n = r.index++;
  if (!e || n >= e.length)
    return r.target = void 0, Ce(void 0, !0);
  switch (t) {
    case "keys":
      return Ce(n, !1);
    case "values":
      return Ce(e[n], !1);
  }
  return Ce([n, e[n]], !1);
}, "values");
xi.Arguments = xi.Array;
var HS = T, zS = vr, pt = zS(HS.process) === "process", qS = M, JS = Pc, XS = O, QS = x, Ni = XS("species"), ZS = function(r) {
  var e = qS(r);
  QS && e && !e[Ni] && JS(e, Ni, {
    configurable: !0,
    get: function() {
      return this;
    }
  });
}, rO = te, eO = TypeError, tO = function(r, e) {
  if (rO(e, r)) return r;
  throw eO("Incorrect invocation");
}, nO = Aa, aO = ne, oO = TypeError, iO = function(r) {
  if (nO(r)) return r;
  throw oO(aO(r) + " is not a constructor");
}, ki = K, sO = iO, cO = Ze, uO = O, lO = uO("species"), yu = function(r, e) {
  var t = ki(r).constructor, n;
  return t === void 0 || cO(n = ki(t)[lO]) ? e : sO(n);
}, vO = TypeError, fO = function(r, e) {
  if (r < e) throw vO("Not enough arguments");
  return r;
}, dO = rt, gu = /(?:ipad|iphone|ipod).*applewebkit/i.test(dO), j = T, pO = pa, $O = ie, Mi = _, hO = A, mu = S, Li = bc, yO = Ma, Fi = Sa, gO = fO, mO = gu, bO = pt, ra = j.setImmediate, Bi = j.clearImmediate, SO = j.process, $n = j.Dispatch, OO = j.Function, Ui = j.MessageChannel, _O = j.String, hn = 0, Gr = {}, Ki = "onreadystatechange", Jr, ar, yn, gn;
mu(function() {
  Jr = j.location;
});
var Fa = function(r) {
  if (hO(Gr, r)) {
    var e = Gr[r];
    delete Gr[r], e();
  }
}, mn = function(r) {
  return function() {
    Fa(r);
  };
}, Gi = function(r) {
  Fa(r.data);
}, Vi = function(r) {
  j.postMessage(_O(r), Jr.protocol + "//" + Jr.host);
};
(!ra || !Bi) && (ra = function(e) {
  gO(arguments.length, 1);
  var t = Mi(e) ? e : OO(e), n = yO(arguments, 1);
  return Gr[++hn] = function() {
    pO(t, void 0, n);
  }, ar(hn), hn;
}, Bi = function(e) {
  delete Gr[e];
}, bO ? ar = function(r) {
  SO.nextTick(mn(r));
} : $n && $n.now ? ar = function(r) {
  $n.now(mn(r));
} : Ui && !mO ? (yn = new Ui(), gn = yn.port2, yn.port1.onmessage = Gi, ar = $O(gn.postMessage, gn)) : j.addEventListener && Mi(j.postMessage) && !j.importScripts && Jr && Jr.protocol !== "file:" && !mu(Vi) ? (ar = Vi, j.addEventListener("message", Gi, !1)) : Ki in Fi("script") ? ar = function(r) {
  Li.appendChild(Fi("script"))[Ki] = function() {
    Li.removeChild(this), Fa(r);
  };
} : ar = function(r) {
  setTimeout(mn(r), 0);
});
var bu = {
  set: ra
}, Su = function() {
  this.head = null, this.tail = null;
};
Su.prototype = {
  add: function(r) {
    var e = { item: r, next: null }, t = this.tail;
    t ? t.next = e : this.head = e, this.tail = e;
  },
  get: function() {
    var r = this.head;
    if (r) {
      var e = this.head = r.next;
      return e === null && (this.tail = null), r.item;
    }
  }
};
var Ou = Su, TO = rt, EO = /ipad|iphone|ipod/i.test(TO) && typeof Pebble < "u", wO = rt, IO = /web0s(?!.*chrome)/i.test(wO), ur = T, Wi = ie, PO = Dr.f, bn = bu.set, RO = Ou, CO = gu, AO = EO, DO = IO, Sn = pt, Yi = ur.MutationObserver || ur.WebKitMutationObserver, Hi = ur.document, zi = ur.process, Ae = ur.Promise, qi = PO(ur, "queueMicrotask"), ea = qi && qi.value, mr, On, _n, De, Ji;
if (!ea) {
  var je = new RO(), xe = function() {
    var r, e;
    for (Sn && (r = zi.domain) && r.exit(); e = je.get(); ) try {
      e();
    } catch (t) {
      throw je.head && mr(), t;
    }
    r && r.enter();
  };
  !CO && !Sn && !DO && Yi && Hi ? (On = !0, _n = Hi.createTextNode(""), new Yi(xe).observe(_n, { characterData: !0 }), mr = function() {
    _n.data = On = !On;
  }) : !AO && Ae && Ae.resolve ? (De = Ae.resolve(void 0), De.constructor = Ae, Ji = Wi(De.then, De), mr = function() {
    Ji(xe);
  }) : Sn ? mr = function() {
    zi.nextTick(xe);
  } : (bn = Wi(bn, ur), mr = function() {
    bn(xe);
  }), ea = function(r) {
    je.head || mr(), je.add(r);
  };
}
var jO = ea, xO = function(r, e) {
  try {
    arguments.length === 1 ? console.error(r) : console.error(r, e);
  } catch {
  }
}, $e = function(r) {
  try {
    return { error: !1, value: r() };
  } catch (e) {
    return { error: !0, value: e };
  }
}, NO = T, Fr = NO.Promise, _u = typeof Deno == "object" && Deno && typeof Deno.version == "object", kO = _u, MO = pt, LO = !kO && !MO && typeof window == "object" && typeof document == "object", FO = T, Vr = Fr, BO = _, UO = $c, KO = Ac, GO = O, VO = LO, WO = _u, Tn = et, Xi = Vr && Vr.prototype, YO = GO("species"), Qi = !1, Tu = BO(FO.PromiseRejectionEvent), HO = UO("Promise", function() {
  var r = KO(Vr), e = r !== String(Vr);
  if (!e && Tn === 66 || !(Xi.catch && Xi.finally)) return !0;
  if (!Tn || Tn < 51 || !/native code/.test(r)) {
    var t = new Vr(function(o) {
      o(1);
    }), n = function(o) {
      o(function() {
      }, function() {
      });
    }, a = t.constructor = {};
    if (a[YO] = n, Qi = t.then(function() {
    }) instanceof n, !Qi) return !0;
  }
  return !e && (VO || WO) && !Tu;
}), he = {
  CONSTRUCTOR: HO,
  REJECTION_EVENT: Tu
}, nr = {}, Zi = V, zO = TypeError, qO = function(r) {
  var e, t;
  this.promise = new r(function(n, a) {
    if (e !== void 0 || t !== void 0) throw zO("Bad Promise constructor");
    e = n, t = a;
  }), this.resolve = Zi(e), this.reject = Zi(t);
};
nr.f = function(r) {
  return new qO(r);
};
var JO = g, ze = pt, Q = T, ye = R, XO = le, QO = Mr, ZO = ZS, r1 = V, ta = _, e1 = N, t1 = tO, n1 = yu, Eu = bu.set, Ba = jO, a1 = xO, o1 = $e, i1 = Ou, wu = st, na = Fr, Iu = he, Pu = nr, $t = "Promise", Ru = Iu.CONSTRUCTOR, s1 = Iu.REJECTION_EVENT, En = wu.getterFor($t), c1 = wu.set, u1 = na && na.prototype, Or = na, wn = u1, Cu = Q.TypeError, aa = Q.document, Ua = Q.process, oa = Pu.f, l1 = oa, v1 = !!(aa && aa.createEvent && Q.dispatchEvent), Au = "unhandledrejection", f1 = "rejectionhandled", rs = 0, Du = 1, d1 = 2, Ka = 1, ju = 2, Ne, es, p1, xu = function(r) {
  var e;
  return e1(r) && ta(e = r.then) ? e : !1;
}, Nu = function(r, e) {
  var t = e.value, n = e.state === Du, a = n ? r.ok : r.fail, o = r.resolve, i = r.reject, s = r.domain, l, c, u;
  try {
    a ? (n || (e.rejection === ju && h1(e), e.rejection = Ka), a === !0 ? l = t : (s && s.enter(), l = a(t), s && (s.exit(), u = !0)), l === r.promise ? i(Cu("Promise-chain cycle")) : (c = xu(l)) ? ye(c, l, o, i) : o(l)) : i(t);
  } catch (v) {
    s && !u && s.exit(), i(v);
  }
}, ku = function(r, e) {
  r.notified || (r.notified = !0, Ba(function() {
    for (var t = r.reactions, n; n = t.get(); )
      Nu(n, r);
    r.notified = !1, e && !r.rejection && $1(r);
  }));
}, Mu = function(r, e, t) {
  var n, a;
  v1 ? (n = aa.createEvent("Event"), n.promise = e, n.reason = t, n.initEvent(r, !1, !0), Q.dispatchEvent(n)) : n = { promise: e, reason: t }, !s1 && (a = Q["on" + r]) ? a(n) : r === Au && a1("Unhandled promise rejection", t);
}, $1 = function(r) {
  ye(Eu, Q, function() {
    var e = r.facade, t = r.value, n = ts(r), a;
    if (n && (a = o1(function() {
      ze ? Ua.emit("unhandledRejection", t, e) : Mu(Au, e, t);
    }), r.rejection = ze || ts(r) ? ju : Ka, a.error))
      throw a.value;
  });
}, ts = function(r) {
  return r.rejection !== Ka && !r.parent;
}, h1 = function(r) {
  ye(Eu, Q, function() {
    var e = r.facade;
    ze ? Ua.emit("rejectionHandled", e) : Mu(f1, e, r.value);
  });
}, _r = function(r, e, t) {
  return function(n) {
    r(e, n, t);
  };
}, Tr = function(r, e, t) {
  r.done || (r.done = !0, t && (r = t), r.value = e, r.state = d1, ku(r, !0));
}, ia = function(r, e, t) {
  if (!r.done) {
    r.done = !0, t && (r = t);
    try {
      if (r.facade === e) throw Cu("Promise can't be resolved itself");
      var n = xu(e);
      n ? Ba(function() {
        var a = { done: !1 };
        try {
          ye(
            n,
            e,
            _r(ia, a, r),
            _r(Tr, a, r)
          );
        } catch (o) {
          Tr(a, o, r);
        }
      }) : (r.value = e, r.state = Du, ku(r, !1));
    } catch (a) {
      Tr({ done: !1 }, a, r);
    }
  }
};
Ru && (Or = function(e) {
  t1(this, wn), r1(e), ye(Ne, this);
  var t = En(this);
  try {
    e(_r(ia, t), _r(Tr, t));
  } catch (n) {
    Tr(t, n);
  }
}, wn = Or.prototype, Ne = function(e) {
  c1(this, {
    type: $t,
    done: !1,
    notified: !1,
    parent: !1,
    reactions: new i1(),
    rejection: !1,
    state: rs,
    value: void 0
  });
}, Ne.prototype = XO(wn, "then", function(e, t) {
  var n = En(this), a = oa(n1(this, Or));
  return n.parent = !0, a.ok = ta(e) ? e : !0, a.fail = ta(t) && t, a.domain = ze ? Ua.domain : void 0, n.state === rs ? n.reactions.add(a) : Ba(function() {
    Nu(a, n);
  }), a.promise;
}), es = function() {
  var r = new Ne(), e = En(r);
  this.promise = r, this.resolve = _r(ia, e), this.reject = _r(Tr, e);
}, Pu.f = oa = function(r) {
  return r === Or || r === p1 ? new es(r) : l1(r);
});
JO({ global: !0, wrap: !0, forced: Ru }, {
  Promise: Or
});
QO(Or, $t, !1, !0);
ZO($t);
var y1 = O, Lu = y1("iterator"), Fu = !1;
try {
  var g1 = 0, ns = {
    next: function() {
      return { done: !!g1++ };
    },
    return: function() {
      Fu = !0;
    }
  };
  ns[Lu] = function() {
    return this;
  }, Array.from(ns, function() {
    throw 2;
  });
} catch {
}
var m1 = function(r, e) {
  if (!e && !Fu) return !1;
  var t = !1;
  try {
    var n = {};
    n[Lu] = function() {
      return {
        next: function() {
          return { done: t = !0 };
        }
      };
    }, r(n);
  } catch {
  }
  return t;
}, b1 = Fr, S1 = m1, O1 = he.CONSTRUCTOR, ht = O1 || !S1(function(r) {
  b1.all(r).then(void 0, function() {
  });
}), _1 = g, T1 = R, E1 = V, w1 = nr, I1 = $e, P1 = pe, R1 = ht;
_1({ target: "Promise", stat: !0, forced: R1 }, {
  all: function(e) {
    var t = this, n = w1.f(t), a = n.resolve, o = n.reject, i = I1(function() {
      var s = E1(t.resolve), l = [], c = 0, u = 1;
      P1(e, function(v) {
        var f = c++, d = !1;
        u++, T1(s, t, v).then(function(p) {
          d || (d = !0, l[f] = p, --u || a(l));
        }, o);
      }), --u || a(l);
    });
    return i.error && o(i.value), n.promise;
  }
});
var C1 = g, A1 = he.CONSTRUCTOR, as = Fr;
as && as.prototype;
C1({ target: "Promise", proto: !0, forced: A1, real: !0 }, {
  catch: function(r) {
    return this.then(void 0, r);
  }
});
var D1 = g, j1 = R, x1 = V, N1 = nr, k1 = $e, M1 = pe, L1 = ht;
D1({ target: "Promise", stat: !0, forced: L1 }, {
  race: function(e) {
    var t = this, n = N1.f(t), a = n.reject, o = k1(function() {
      var i = x1(t.resolve);
      M1(e, function(s) {
        j1(i, t, s).then(n.resolve, a);
      });
    });
    return o.error && a(o.value), n.promise;
  }
});
var F1 = g, B1 = R, U1 = nr, K1 = he.CONSTRUCTOR;
F1({ target: "Promise", stat: !0, forced: K1 }, {
  reject: function(e) {
    var t = U1.f(this);
    return B1(t.reject, void 0, e), t.promise;
  }
});
var G1 = K, V1 = N, W1 = nr, Bu = function(r, e) {
  if (G1(r), V1(e) && e.constructor === r) return e;
  var t = W1.f(r), n = t.resolve;
  return n(e), t.promise;
}, Y1 = g, H1 = M, z1 = Tp, q1 = Fr, J1 = he.CONSTRUCTOR, X1 = Bu, Q1 = H1("Promise"), Z1 = !J1;
Y1({ target: "Promise", stat: !0, forced: z1 }, {
  resolve: function(e) {
    return X1(Z1 && this === Q1 ? q1 : this, e);
  }
});
var r_ = g, e_ = R, t_ = V, n_ = nr, a_ = $e, o_ = pe, i_ = ht;
r_({ target: "Promise", stat: !0, forced: i_ }, {
  allSettled: function(e) {
    var t = this, n = n_.f(t), a = n.resolve, o = n.reject, i = a_(function() {
      var s = t_(t.resolve), l = [], c = 0, u = 1;
      o_(e, function(v) {
        var f = c++, d = !1;
        u++, e_(s, t, v).then(function(p) {
          d || (d = !0, l[f] = { status: "fulfilled", value: p }, --u || a(l));
        }, function(p) {
          d || (d = !0, l[f] = { status: "rejected", reason: p }, --u || a(l));
        });
      }), --u || a(l);
    });
    return i.error && o(i.value), n.promise;
  }
});
var s_ = g, c_ = R, u_ = V, l_ = M, v_ = nr, f_ = $e, d_ = pe, p_ = ht, os = "No one promise resolved";
s_({ target: "Promise", stat: !0, forced: p_ }, {
  any: function(e) {
    var t = this, n = l_("AggregateError"), a = v_.f(t), o = a.resolve, i = a.reject, s = f_(function() {
      var l = u_(t.resolve), c = [], u = 0, v = 1, f = !1;
      d_(e, function(d) {
        var p = u++, y = !1;
        v++, c_(l, t, d).then(function($) {
          y || f || (f = !0, o($));
        }, function($) {
          y || f || (y = !0, c[p] = $, --v || i(new n(c, os)));
        });
      }), --v || i(new n(c, os));
    });
    return s.error && i(s.value), a.promise;
  }
});
var $_ = g, sa = Fr, h_ = S, y_ = M, g_ = _, m_ = yu, is = Bu, b_ = sa && sa.prototype, S_ = !!sa && h_(function() {
  b_.finally.call({ then: function() {
  } }, function() {
  });
});
$_({ target: "Promise", proto: !0, real: !0, forced: S_ }, {
  finally: function(r) {
    var e = m_(this, y_("Promise")), t = g_(r);
    return this.then(
      t ? function(n) {
        return is(e, r()).then(function() {
          return n;
        });
      } : r,
      t ? function(n) {
        return is(e, r()).then(function() {
          throw n;
        });
      } : r
    );
  }
});
var Ga = E, O_ = _a, __ = kr, T_ = ya, E_ = Ga("".charAt), ss = Ga("".charCodeAt), w_ = Ga("".slice), I_ = function(r) {
  return function(e, t) {
    var n = __(T_(e)), a = O_(t), o = n.length, i, s;
    return a < 0 || a >= o ? "" : (i = ss(n, a), i < 55296 || i > 56319 || a + 1 === o || (s = ss(n, a + 1)) < 56320 || s > 57343 ? E_(n, a) : w_(n, a, a + 2));
  };
}, P_ = {
  // `String.prototype.at` method
  // https://github.com/mathiasbynens/String.prototype.at
  charAt: I_()
}, R_ = P_.charAt, C_ = kr, Uu = st, A_ = du, cs = pu, Ku = "String Iterator", D_ = Uu.set, j_ = Uu.getterFor(Ku);
A_(String, "String", function(r) {
  D_(this, {
    type: Ku,
    string: C_(r),
    index: 0
  });
}, function() {
  var e = j_(this), t = e.string, n = e.index, a;
  return n >= t.length ? cs(void 0, !0) : (a = R_(t, n), e.index += a.length, cs(a, !1));
});
var x_ = k, N_ = x_.Promise, k_ = {
  CSSRuleList: 0,
  CSSStyleDeclaration: 0,
  CSSValueList: 0,
  ClientRectList: 0,
  DOMRectList: 0,
  DOMStringList: 0,
  DOMTokenList: 1,
  DataTransferItemList: 0,
  FileList: 0,
  HTMLAllCollection: 0,
  HTMLCollection: 0,
  HTMLFormElement: 0,
  HTMLSelectElement: 0,
  MediaList: 0,
  MimeTypeArray: 0,
  NamedNodeMap: 0,
  NodeList: 1,
  PaintRequestList: 0,
  Plugin: 0,
  PluginArray: 0,
  SVGLengthList: 0,
  SVGNumberList: 0,
  SVGPathSegList: 0,
  SVGPointList: 0,
  SVGStringList: 0,
  SVGTransformList: 0,
  SourceBufferList: 0,
  StyleSheetList: 0,
  TextTrackCueList: 0,
  TextTrackList: 0,
  TouchList: 0
}, M_ = k_, L_ = T, F_ = ue, B_ = tr, us = Lr, U_ = O, ls = U_("toStringTag");
for (var In in M_) {
  var vs = L_[In], Pn = vs && vs.prototype;
  Pn && F_(Pn) !== ls && B_(Pn, ls, In), us[In] = us.Array;
}
var K_ = N_, G_ = K_, V_ = G_, W_ = /* @__PURE__ */ Md(V_), Y_ = TypeError, H_ = 9007199254740991, z_ = function(r) {
  if (r > H_) throw Y_("Maximum allowed index exceeded");
  return r;
}, q_ = S, J_ = O, X_ = et, Q_ = J_("species"), Gu = function(r) {
  return X_ >= 51 || !q_(function() {
    var e = [], t = e.constructor = {};
    return t[Q_] = function() {
      return { foo: 1 };
    }, e[r](Boolean).foo !== 1;
  });
}, Z_ = g, rT = S, eT = ct, tT = N, nT = xr, aT = Nr, fs = z_, ds = Ra, oT = Rg, iT = Gu, sT = O, cT = et, Vu = sT("isConcatSpreadable"), uT = cT >= 51 || !rT(function() {
  var r = [];
  return r[Vu] = !1, r.concat()[0] !== r;
}), lT = function(r) {
  if (!tT(r)) return !1;
  var e = r[Vu];
  return e !== void 0 ? !!e : eT(r);
}, vT = !uT || !iT("concat");
Z_({ target: "Array", proto: !0, forced: vT }, {
  // eslint-disable-next-line no-unused-vars -- required for `.length`
  concat: function(e) {
    var t = nT(this), n = oT(t, 0), a = 0, o, i, s, l, c;
    for (o = -1, s = arguments.length; o < s; o++)
      if (c = o === -1 ? t : arguments[o], lT(c))
        for (l = aT(c), fs(a + l), i = 0; i < l; i++, a++) i in c && ds(n, a, c[i]);
      else
        fs(a + 1), ds(n, a++, c);
    return n.length = a, n;
  }
});
var fT = D;
fT("asyncIterator");
var dT = D;
dT("hasInstance");
var pT = D;
pT("isConcatSpreadable");
var $T = D;
$T("iterator");
var hT = D;
hT("match");
var yT = D;
yT("matchAll");
var gT = D;
gT("replace");
var mT = D;
mT("search");
var bT = D;
bT("species");
var ST = D;
ST("split");
var OT = D, _T = Rc;
OT("toPrimitive");
_T();
var TT = M, ET = D, wT = Mr;
ET("toStringTag");
wT(TT("Symbol"), "Symbol");
var IT = D;
IT("unscopables");
var PT = T, RT = Mr;
RT(PT.JSON, "JSON", !0);
var CT = k;
CT.Symbol;
var AT = ve;
AT.f("iterator");
var DT = Ia;
DT("Array").concat;
var jT = g, ps = ct, xT = Aa, NT = N, $s = Ta, kT = Nr, MT = q, LT = Ra, FT = O, BT = Gu, UT = Ma, KT = BT("slice"), GT = FT("species"), Rn = Array, VT = Math.max;
jT({ target: "Array", proto: !0, forced: !KT }, {
  slice: function(e, t) {
    var n = MT(this), a = kT(n), o = $s(e, a), i = $s(t === void 0 ? a : t, a), s, l, c;
    if (ps(n) && (s = n.constructor, xT(s) && (s === Rn || ps(s.prototype)) ? s = void 0 : NT(s) && (s = s[GT], s === null && (s = void 0)), s === Rn || s === void 0))
      return UT(n, o, i);
    for (l = new (s === void 0 ? Rn : s)(VT(i - o, 0)), c = 0; o < i; o++, c++) o in n && LT(l, c, n[o]);
    return l.length = c, l;
  }
});
var WT = Ia;
WT("Array").slice;
var YT = ve;
YT.f("asyncIterator");
function Cn(r, e, t, n) {
  function a(o) {
    return o instanceof t ? o : new t(function(i) {
      i(o);
    });
  }
  return new (t || (t = W_))(function(o, i) {
    function s(u) {
      try {
        c(n.next(u));
      } catch (v) {
        i(v);
      }
    }
    function l(u) {
      try {
        c(n.throw(u));
      } catch (v) {
        i(v);
      }
    }
    function c(u) {
      u.done ? o(u.value) : a(u.value).then(s, l);
    }
    c((n = n.apply(r, [])).next());
  });
}
class HT {
  /** Checks whether the app is running as an electron application. */
  isElectron() {
    var e;
    return window.electron ? !!window.electron : !!(!((e = process == null ? void 0 : process.versions) === null || e === void 0) && e.electron) || /electron/i.test(navigator.userAgent);
  }
  /**
   * Gets the electron version.
   *
   * version 0.0.0 represents a unsupported version
   */
  getVersion() {
    return Cn(this, void 0, void 0, function* () {
      return window.electron ? (yield window.electron.getVersion()).split("-")[0] : "0.0.0";
    });
  }
  /** Checks if the running Electron build is a standalone (non auto-updating windows version) */
  isStandaloneBuild() {
    return Cn(this, void 0, void 0, function* () {
      var e;
      return !((e = window.electron) === null || e === void 0) && e.isStandaloneBuild ? yield window.electron.isStandaloneBuild() : null;
    });
  }
  /** Checks if the running Electron build is installed from an windows MSI installer */
  isMsiBuild() {
    return Cn(this, void 0, void 0, function* () {
      var e;
      return !((e = window.electron) === null || e === void 0) && e.isMsiBuild ? yield window.electron.isMsiBuild() : null;
    });
  }
}
const hs = new HT();
function zT(r, e) {
  return ys(r), ys(e), r.localeCompare(e, void 0, {
    numeric: !0
  });
}
function ys(r) {
  if (r.split(".").length !== 3)
    throw Error(`The version '${r}' must be in the format 'x.x.x'.`);
}
const qT = Object.prototype.toString;
function JT(r, e) {
  return qT.call(r) === `[object ${e}]`;
}
function XT(r) {
  return JT(r, "Object");
}
function QT(r) {
  return !!(r && r.then && typeof r.then == "function");
}
const Wr = "8.36.0", z = globalThis;
function Va(r, e, t) {
  const n = t || z, a = n.__SENTRY__ = n.__SENTRY__ || {}, o = a[Wr] = a[Wr] || {};
  return o[r] || (o[r] = e());
}
const Wu = typeof __SENTRY_DEBUG__ > "u" || __SENTRY_DEBUG__, ZT = "Sentry Logger ", gs = [
  "debug",
  "info",
  "warn",
  "error",
  "log",
  "assert",
  "trace"
], ms = {};
function Yu(r) {
  if (!("console" in z))
    return r();
  const e = z.console, t = {}, n = Object.keys(ms);
  n.forEach((a) => {
    const o = ms[a];
    t[a] = e[a], e[a] = o;
  });
  try {
    return r();
  } finally {
    n.forEach((a) => {
      e[a] = t[a];
    });
  }
}
function rE() {
  let r = !1;
  const e = {
    enable: () => {
      r = !0;
    },
    disable: () => {
      r = !1;
    },
    isEnabled: () => r
  };
  return Wu ? gs.forEach((t) => {
    e[t] = (...n) => {
      r && Yu(() => {
        z.console[t](`${ZT}[${t}]:`, ...n);
      });
    };
  }) : gs.forEach((t) => {
    e[t] = () => {
    };
  }), e;
}
const Be = Va("logger", rE);
function eE(r, e, t) {
  try {
    Object.defineProperty(r, e, {
      // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
      value: t,
      writable: !0,
      configurable: !0
    });
  } catch {
    Wu && Be.log(`Failed to add non-enumerable property "${e}" to object`, r);
  }
}
const Hu = 1e3;
function Wa() {
  return Date.now() / Hu;
}
function tE() {
  const { performance: r } = z;
  if (!r || !r.now)
    return Wa;
  const e = Date.now() - r.now(), t = r.timeOrigin == null ? e : r.timeOrigin;
  return () => (t + r.now()) / Hu;
}
const nE = tE();
(() => {
  const { performance: r } = z;
  if (!r || !r.now)
    return;
  const e = 3600 * 1e3, t = r.now(), n = Date.now(), a = r.timeOrigin ? Math.abs(r.timeOrigin + t - n) : e, o = a < e, i = r.timing && r.timing.navigationStart, l = typeof i == "number" ? Math.abs(i + t - n) : e, c = l < e;
  return o || c ? a <= l ? r.timeOrigin : i : n;
})();
function Er() {
  const r = z, e = r.crypto || r.msCrypto;
  let t = () => Math.random() * 16;
  try {
    if (e && e.randomUUID)
      return e.randomUUID().replace(/-/g, "");
    e && e.getRandomValues && (t = () => {
      const n = new Uint8Array(1);
      return e.getRandomValues(n), n[0];
    });
  } catch {
  }
  return ("10000000100040008000" + 1e11).replace(
    /[018]/g,
    (n) => (
      // eslint-disable-next-line no-bitwise
      (n ^ (t() & 15) >> n / 4).toString(16)
    )
  );
}
function bs() {
  return {
    traceId: Er(),
    spanId: Er().substring(16)
  };
}
function Ya() {
  return Ha(z), z;
}
function Ha(r) {
  const e = r.__SENTRY__ = r.__SENTRY__ || {};
  return e.version = e.version || Wr, e[Wr] = e[Wr] || {};
}
function aE(r, e = {}) {
  if (e.user && (!r.ipAddress && e.user.ip_address && (r.ipAddress = e.user.ip_address), !r.did && !e.did && (r.did = e.user.id || e.user.email || e.user.username)), r.timestamp = e.timestamp || nE(), e.abnormal_mechanism && (r.abnormal_mechanism = e.abnormal_mechanism), e.ignoreDuration && (r.ignoreDuration = e.ignoreDuration), e.sid && (r.sid = e.sid.length === 32 ? e.sid : Er()), e.init !== void 0 && (r.init = e.init), !r.did && e.did && (r.did = `${e.did}`), typeof e.started == "number" && (r.started = e.started), r.ignoreDuration)
    r.duration = void 0;
  else if (typeof e.duration == "number")
    r.duration = e.duration;
  else {
    const t = r.timestamp - r.started;
    r.duration = t >= 0 ? t : 0;
  }
  e.release && (r.release = e.release), e.environment && (r.environment = e.environment), !r.ipAddress && e.ipAddress && (r.ipAddress = e.ipAddress), !r.userAgent && e.userAgent && (r.userAgent = e.userAgent), typeof e.errors == "number" && (r.errors = e.errors), e.status && (r.status = e.status);
}
const ca = "_sentrySpan";
function Ss(r, e) {
  e ? eE(r, ca, e) : delete r[ca];
}
function Os(r) {
  return r[ca];
}
const oE = 100;
class za {
  /** Flag if notifying is happening. */
  /** Callback for client to receive scope changes. */
  /** Callback list that will be called during event processing. */
  /** Array of breadcrumbs. */
  /** User */
  /** Tags */
  /** Extra */
  /** Contexts */
  /** Attachments */
  /** Propagation Context for distributed tracing */
  /**
   * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
   * sent to Sentry
   */
  /** Fingerprint */
  /** Severity */
  /**
   * Transaction Name
   *
   * IMPORTANT: The transaction name on the scope has nothing to do with root spans/transaction objects.
   * It's purpose is to assign a transaction to the scope that's added to non-transaction events.
   */
  /** Session */
  /** Request Mode Session Status */
  /** The client on this scope */
  /** Contains the last event id of a captured event.  */
  // NOTE: Any field which gets added here should get added not only to the constructor but also to the `clone` method.
  constructor() {
    this._notifyingListeners = !1, this._scopeListeners = [], this._eventProcessors = [], this._breadcrumbs = [], this._attachments = [], this._user = {}, this._tags = {}, this._extra = {}, this._contexts = {}, this._sdkProcessingMetadata = {}, this._propagationContext = bs();
  }
  /**
   * @inheritDoc
   */
  clone() {
    const e = new za();
    return e._breadcrumbs = [...this._breadcrumbs], e._tags = { ...this._tags }, e._extra = { ...this._extra }, e._contexts = { ...this._contexts }, e._user = this._user, e._level = this._level, e._session = this._session, e._transactionName = this._transactionName, e._fingerprint = this._fingerprint, e._eventProcessors = [...this._eventProcessors], e._requestSession = this._requestSession, e._attachments = [...this._attachments], e._sdkProcessingMetadata = { ...this._sdkProcessingMetadata }, e._propagationContext = { ...this._propagationContext }, e._client = this._client, e._lastEventId = this._lastEventId, Ss(e, Os(this)), e;
  }
  /**
   * @inheritDoc
   */
  setClient(e) {
    this._client = e;
  }
  /**
   * @inheritDoc
   */
  setLastEventId(e) {
    this._lastEventId = e;
  }
  /**
   * @inheritDoc
   */
  getClient() {
    return this._client;
  }
  /**
   * @inheritDoc
   */
  lastEventId() {
    return this._lastEventId;
  }
  /**
   * @inheritDoc
   */
  addScopeListener(e) {
    this._scopeListeners.push(e);
  }
  /**
   * @inheritDoc
   */
  addEventProcessor(e) {
    return this._eventProcessors.push(e), this;
  }
  /**
   * @inheritDoc
   */
  setUser(e) {
    return this._user = e || {
      email: void 0,
      id: void 0,
      ip_address: void 0,
      username: void 0
    }, this._session && aE(this._session, { user: e }), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getUser() {
    return this._user;
  }
  /**
   * @inheritDoc
   */
  getRequestSession() {
    return this._requestSession;
  }
  /**
   * @inheritDoc
   */
  setRequestSession(e) {
    return this._requestSession = e, this;
  }
  /**
   * @inheritDoc
   */
  setTags(e) {
    return this._tags = {
      ...this._tags,
      ...e
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTag(e, t) {
    return this._tags = { ...this._tags, [e]: t }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtras(e) {
    return this._extra = {
      ...this._extra,
      ...e
    }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setExtra(e, t) {
    return this._extra = { ...this._extra, [e]: t }, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setFingerprint(e) {
    return this._fingerprint = e, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setLevel(e) {
    return this._level = e, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setTransactionName(e) {
    return this._transactionName = e, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setContext(e, t) {
    return t === null ? delete this._contexts[e] : this._contexts[e] = t, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  setSession(e) {
    return e ? this._session = e : delete this._session, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getSession() {
    return this._session;
  }
  /**
   * @inheritDoc
   */
  update(e) {
    if (!e)
      return this;
    const t = typeof e == "function" ? e(this) : e, [n, a] = t instanceof Cr ? [t.getScopeData(), t.getRequestSession()] : XT(t) ? [e, e.requestSession] : [], { tags: o, extra: i, user: s, contexts: l, level: c, fingerprint: u = [], propagationContext: v } = n || {};
    return this._tags = { ...this._tags, ...o }, this._extra = { ...this._extra, ...i }, this._contexts = { ...this._contexts, ...l }, s && Object.keys(s).length && (this._user = s), c && (this._level = c), u.length && (this._fingerprint = u), v && (this._propagationContext = v), a && (this._requestSession = a), this;
  }
  /**
   * @inheritDoc
   */
  clear() {
    return this._breadcrumbs = [], this._tags = {}, this._extra = {}, this._user = {}, this._contexts = {}, this._level = void 0, this._transactionName = void 0, this._fingerprint = void 0, this._requestSession = void 0, this._session = void 0, Ss(this, void 0), this._attachments = [], this._propagationContext = bs(), this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addBreadcrumb(e, t) {
    const n = typeof t == "number" ? t : oE;
    if (n <= 0)
      return this;
    const a = {
      timestamp: Wa(),
      ...e
    }, o = this._breadcrumbs;
    return o.push(a), this._breadcrumbs = o.length > n ? o.slice(-n) : o, this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  getLastBreadcrumb() {
    return this._breadcrumbs[this._breadcrumbs.length - 1];
  }
  /**
   * @inheritDoc
   */
  clearBreadcrumbs() {
    return this._breadcrumbs = [], this._notifyScopeListeners(), this;
  }
  /**
   * @inheritDoc
   */
  addAttachment(e) {
    return this._attachments.push(e), this;
  }
  /**
   * @inheritDoc
   */
  clearAttachments() {
    return this._attachments = [], this;
  }
  /** @inheritDoc */
  getScopeData() {
    return {
      breadcrumbs: this._breadcrumbs,
      attachments: this._attachments,
      contexts: this._contexts,
      tags: this._tags,
      extra: this._extra,
      user: this._user,
      level: this._level,
      fingerprint: this._fingerprint || [],
      eventProcessors: this._eventProcessors,
      propagationContext: this._propagationContext,
      sdkProcessingMetadata: this._sdkProcessingMetadata,
      transactionName: this._transactionName,
      span: Os(this)
    };
  }
  /**
   * @inheritDoc
   */
  setSDKProcessingMetadata(e) {
    return this._sdkProcessingMetadata = { ...this._sdkProcessingMetadata, ...e }, this;
  }
  /**
   * @inheritDoc
   */
  setPropagationContext(e) {
    return this._propagationContext = e, this;
  }
  /**
   * @inheritDoc
   */
  getPropagationContext() {
    return this._propagationContext;
  }
  /**
   * @inheritDoc
   */
  captureException(e, t) {
    const n = t && t.event_id ? t.event_id : Er();
    if (!this._client)
      return Be.warn("No client configured on scope - will not capture exception!"), n;
    const a = new Error("Sentry syntheticException");
    return this._client.captureException(
      e,
      {
        originalException: e,
        syntheticException: a,
        ...t,
        event_id: n
      },
      this
    ), n;
  }
  /**
   * @inheritDoc
   */
  captureMessage(e, t, n) {
    const a = n && n.event_id ? n.event_id : Er();
    if (!this._client)
      return Be.warn("No client configured on scope - will not capture message!"), a;
    const o = new Error(e);
    return this._client.captureMessage(
      e,
      t,
      {
        originalException: e,
        syntheticException: o,
        ...n,
        event_id: a
      },
      this
    ), a;
  }
  /**
   * @inheritDoc
   */
  captureEvent(e, t) {
    const n = t && t.event_id ? t.event_id : Er();
    return this._client ? (this._client.captureEvent(e, { ...t, event_id: n }, this), n) : (Be.warn("No client configured on scope - will not capture event!"), n);
  }
  /**
   * This will be called on every set call.
   */
  _notifyScopeListeners() {
    this._notifyingListeners || (this._notifyingListeners = !0, this._scopeListeners.forEach((e) => {
      e(this);
    }), this._notifyingListeners = !1);
  }
}
const Cr = za;
function iE() {
  return Va("defaultCurrentScope", () => new Cr());
}
function sE() {
  return Va("defaultIsolationScope", () => new Cr());
}
class cE {
  constructor(e, t) {
    let n;
    e ? n = e : n = new Cr();
    let a;
    t ? a = t : a = new Cr(), this._stack = [{ scope: n }], this._isolationScope = a;
  }
  /**
   * Fork a scope for the stack.
   */
  withScope(e) {
    const t = this._pushScope();
    let n;
    try {
      n = e(t);
    } catch (a) {
      throw this._popScope(), a;
    }
    return QT(n) ? n.then(
      (a) => (this._popScope(), a),
      (a) => {
        throw this._popScope(), a;
      }
    ) : (this._popScope(), n);
  }
  /**
   * Get the client of the stack.
   */
  getClient() {
    return this.getStackTop().client;
  }
  /**
   * Returns the scope of the top stack.
   */
  getScope() {
    return this.getStackTop().scope;
  }
  /**
   * Get the isolation scope for the stack.
   */
  getIsolationScope() {
    return this._isolationScope;
  }
  /**
   * Returns the topmost scope layer in the order domain > local > process.
   */
  getStackTop() {
    return this._stack[this._stack.length - 1];
  }
  /**
   * Push a scope to the stack.
   */
  _pushScope() {
    const e = this.getScope().clone();
    return this._stack.push({
      client: this.getClient(),
      scope: e
    }), e;
  }
  /**
   * Pop a scope from the stack.
   */
  _popScope() {
    return this._stack.length <= 1 ? !1 : !!this._stack.pop();
  }
}
function Ar() {
  const r = Ya(), e = Ha(r);
  return e.stack = e.stack || new cE(iE(), sE());
}
function uE(r) {
  return Ar().withScope(r);
}
function lE(r, e) {
  const t = Ar();
  return t.withScope(() => (t.getStackTop().scope = r, e(r)));
}
function _s(r) {
  return Ar().withScope(() => r(Ar().getIsolationScope()));
}
function vE() {
  return {
    withIsolationScope: _s,
    withScope: uE,
    withSetScope: lE,
    withSetIsolationScope: (r, e) => _s(e),
    getCurrentScope: () => Ar().getScope(),
    getIsolationScope: () => Ar().getIsolationScope()
  };
}
function zu(r) {
  const e = Ha(r);
  return e.acs ? e.acs : vE();
}
function qa() {
  const r = Ya();
  return zu(r).getCurrentScope();
}
function qu() {
  const r = Ya();
  return zu(r).getIsolationScope();
}
function fE() {
  return qa().getClient();
}
function dE(r) {
  if (r)
    return pE(r) ? { captureContext: r } : hE(r) ? {
      captureContext: r
    } : r;
}
function pE(r) {
  return r instanceof Cr || typeof r == "function";
}
const $E = [
  "user",
  "level",
  "extra",
  "contexts",
  "tags",
  "fingerprint",
  "requestSession",
  "propagationContext"
];
function hE(r) {
  return Object.keys(r).some((e) => $E.includes(e));
}
function Ts(r, e) {
  return qa().captureException(r, dE(e));
}
function yE(r, e) {
  const t = typeof e == "string" ? e : void 0, n = typeof e != "string" ? { captureContext: e } : void 0;
  return qa().captureMessage(r, t, n);
}
function gE(r, e) {
  qu().setContext(r, e);
}
const mE = 100;
function ir(r, e) {
  const t = fE(), n = qu();
  if (!t) return;
  const { beforeBreadcrumb: a = null, maxBreadcrumbs: o = mE } = t.getOptions();
  if (o <= 0) return;
  const s = { timestamp: Wa(), ...r }, l = a ? Yu(() => a(s, e)) : s;
  l !== null && (t.emit && t.emit("beforeAddBreadcrumb", l, e), n.addBreadcrumb(l, o));
}
var Xr;
(function(r) {
  r.Unknown = "unknown", r.Core = "core", r.Routing = "routing-and-presence", r.Insights = "insights", r.Ecosystem = "ecosystem", r.Partners = "partners", r.Channels = "channels", r.Messaging = "messaging", r.Platform = "platform", r.AI = "ai", r.Conversations = "conversations", r.Automation = "automation";
})(Xr || (Xr = {}));
function wr(r) {
  const e = r.split(".")[1];
  if (!e)
    throw Error("Invalid token");
  const t = e.replace(/-/g, "+").replace(/_/g, "/");
  try {
    return JSON.parse(Buffer.from(t, "base64").toString());
  } catch (n) {
    throw Error(`Failed to parse the JSON Web Token with the following error: ${n}`);
  }
}
const bE = Yr.backendDomain ? {
  "backend-domain": Yr.backendDomain
} : void 0;
function Ue() {
  const r = new URLSearchParams(Object.assign({ noToken: "true" }, bE)).toString();
  document.location.href = `${Yr.url.logIn}?${r}`;
}
const An = "authData", Dn = 30, SE = 600, jn = 5;
class OE {
  constructor() {
    Object.defineProperty(this, "authData", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: null
    }), Object.defineProperty(this, "accessTokenExpiresAt", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    }), Object.defineProperty(this, "clientServerTimeDiff", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    });
  }
  /**
   * Returns an estimated server time (unix epoch in seconds) by adding the
   * client-server time difference to the current client time.
   *
   * The time-diff is stored whenever a new access token is saved.
   *
   * @returns {number} The estimated server time in seconds.
   */
  estimatedServerTime() {
    const e = Date.now() / 1e3;
    return this.clientServerTimeDiff >= jn || this.clientServerTimeDiff <= -jn ? Math.ceil(e + this.clientServerTimeDiff) : Math.ceil(e);
  }
  /**
   * Sets the auth data in localStorage.
   *
   * @param authData The auth data.
   */
  setAuthData(e) {
    this.authData = e;
    const n = Math.ceil(Date.now() / 1e3) + SE, a = wr(e.access_token).exp;
    if (this.clientServerTimeDiff = a - n, process.env.NODE_ENV !== "test" && Math.abs(this.clientServerTimeDiff) > jn) {
      const o = this.clientServerTimeDiff > 0 ? "behind" : "ahead";
      console.info(`Client time is ${o} by significant amount. (${Math.abs(this.clientServerTimeDiff)}s)`);
    }
    this.accessTokenExpiresAt = a, localStorage.setItem(An, JSON.stringify(e));
  }
  /** Gets the auth data from memory or localStorage. */
  getAuthData() {
    if (this.authData)
      return this.authData;
    const e = localStorage.getItem(An), t = e ? JSON.parse(e) : null;
    return this.validateAuthDataComplete(t) && (this.authData = t), t;
  }
  /** Removes the auth data from localStorage. */
  removeAuthData() {
    this.authData = null, localStorage.removeItem(An);
  }
  getAccessToken() {
    var e;
    return ((e = this.authData) === null || e === void 0 ? void 0 : e.access_token) || null;
  }
  getRefreshToken() {
    var e;
    return ((e = this.authData) === null || e === void 0 ? void 0 : e.refresh_token) || null;
  }
  /**
   * Validates that the auth data is complete - i.e not fragmented.
   *
   * @param authData The auth data.
   */
  validateAuthDataComplete(e) {
    return e ? [
      "access_token",
      "refresh_token",
      "expires_in"
    ].every((n) => typeof e[n] < "u") : !1;
  }
  isAccessTokenExpired() {
    if (!this.getAccessToken())
      return !0;
    const t = this.accessTokenExpiresAt - Dn;
    return this.estimatedServerTime() >= t;
  }
  isRefreshTokenExpired(e) {
    if (!e)
      return !0;
    const t = wr(e), n = t.exp - Dn;
    return !t || this.estimatedServerTime() >= n;
  }
  accessTokenExpiresInMs() {
    return (this.accessTokenExpiresAt - Dn - this.estimatedServerTime()) * 1e3;
  }
}
const P = new OE();
var _E = function(r, e, t, n) {
  function a(o) {
    return o instanceof t ? o : new t(function(i) {
      i(o);
    });
  }
  return new (t || (t = Promise))(function(o, i) {
    function s(u) {
      try {
        c(n.next(u));
      } catch (v) {
        i(v);
      }
    }
    function l(u) {
      try {
        c(n.throw(u));
      } catch (v) {
        i(v);
      }
    }
    function c(u) {
      u.done ? o(u.value) : a(u.value).then(s, l);
    }
    c((n = n.apply(r, e || [])).next());
  });
};
function TE(r) {
  return _E(this, void 0, void 0, function* () {
    var e, t;
    const n = window.location.origin.replace(/^https?:\/\//, ""), a = ["localhost:8080", "uptrends-monitor"];
    if (!(!r.response || a.some((o) => n.includes(o)))) {
      try {
        const o = (e = r.response.config.headers.Authorization) !== null && e !== void 0 ? e : "", i = o ? (t = o.toString()) === null || t === void 0 ? void 0 : t.split("Basic ")[1] : "", s = i ? atob(i).split("token:")[1] : "", l = s ? wr(s).exp : "None", c = yield Ja.getAuthData({ localStorageOnly: !0 }), u = Math.floor(Date.now() / 1e3), v = c?.access_token, f = c?.refresh_token, d = v ? wr(v).exp : "None", p = f ? wr(f).exp : "None", y = typeof l == "number" ? u - l : "Unknown", $ = typeof d == "number" ? u - d : "Unknown", b = typeof p == "number" ? u - p : "Unknown", I = r.response.headers["x-dixa-rid"];
        gE("Expires", {
          currentTimestamp: u,
          accessTokenFromHeader: l,
          accessTokenFromHeaderDiff: y,
          accessTokenFromLocalStorage: d,
          accessTokenFromLocalStorageDiff: $,
          refreshTokenFromLocalStorage: p,
          refreshTokenFromLocalStorageDiff: b,
          xDixaRid: I,
          navigatorOnline: navigator.onLine
        });
      } catch (o) {
        console.error("Error adding Sentry error context", o);
      }
      yE("401 unauthorized interceptor", {
        level: "debug",
        tags: {
          team: Xr.Platform,
          domain: n
        }
      });
    }
  });
}
const xn = /* @__PURE__ */ new Map(), EE = 3;
function wE(r) {
  r.interceptors.response.use((e) => (xn.delete(e.config.url), e), (e) => {
    var t;
    if (e.response) {
      const { status: n } = e.response;
      switch (n) {
        case ua.Unauthorized:
          if (!Ja.isRefreshTokenExpired() && e.config) {
            ir({
              category: "errorInterceptor",
              message: "Access token expired after request",
              level: "debug"
            });
            const a = (t = xn.get(e.config.url)) !== null && t !== void 0 ? t : 0;
            if (console.log(`Retrying request (${a + 1}): ${e.config.url}`), a <= EE)
              return xn.set(e.config.url, a + 1), r(e.config);
          }
          TE(e), console.error("401 unauthorized interceptor"), Ue();
          break;
      }
    }
    return Promise.reject(e);
  });
}
var J = function(r, e, t, n) {
  function a(o) {
    return o instanceof t ? o : new t(function(i) {
      i(o);
    });
  }
  return new (t || (t = Promise))(function(o, i) {
    function s(u) {
      try {
        c(n.next(u));
      } catch (v) {
        i(v);
      }
    }
    function l(u) {
      try {
        c(n.throw(u));
      } catch (v) {
        i(v);
      }
    }
    function c(u) {
      u.done ? o(u.value) : a(u.value).then(s, l);
    }
    c((n = n.apply(r, e || [])).next());
  });
};
const Ju = ws.create();
wE(Ju);
const W = console.log;
function Es(r) {
  return J(this, void 0, void 0, function* () {
    return new Promise((e) => setTimeout(e, r * 1e3));
  });
}
class IE extends Error {
  constructor(e, t) {
    super(e, t);
  }
}
function PE(r = 0) {
  return Math.min(Math.round((Math.random() + 1) * Math.pow(1.5, r)), 30);
}
const RE = 5;
class CE {
  constructor() {
    Object.defineProperty(this, "authDataPromise", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: null
    }), Object.defineProperty(this, "retryCount", {
      enumerable: !0,
      configurable: !0,
      writable: !0,
      value: 0
    });
  }
  init(e) {
    return J(this, void 0, void 0, function* () {
      const t = yield this.refresh(e);
      if (t)
        P.setAuthData(t);
      else {
        const n = P.isRefreshTokenExpired(e) ? "expired" : "unknown";
        throw new IE("Failed to init refresh token", {
          cause: n
        });
      }
    });
  }
  getDebugInfo() {
    const e = P.getAccessToken();
    if (!e)
      return {};
    const t = wr(e), { exp: n } = t;
    return {
      expire: n ? new Date(n * 1e3).toISOString() : null,
      now: (/* @__PURE__ */ new Date()).toISOString()
    };
  }
  /**
   * Gets auth data from LocalStorage, or fetches new auth data if the current
   * token is expired or is about to expire.
   */
  getAuthData() {
    return J(this, arguments, void 0, function* ({ localStorageOnly: e = !1 } = {}) {
      if (e)
        return P.getAuthData();
      if (this.authDataPromise)
        return yield this.authDataPromise;
      const t = P.getAuthData();
      return t ? P.isAccessTokenExpired() ? (ir({
        category: "refreshToken",
        // Cannot include "token" in the message, as it will be redacted
        message: "expired or about to expire",
        level: "debug",
        data: this.getDebugInfo()
      }), this.authDataPromise = this.refresh(t.refresh_token).then((n) => (n && P.setAuthData(n), this.authDataPromise = null, n)), yield this.authDataPromise) : t : null;
    });
  }
  removeAuthData() {
    return P.removeAuthData();
  }
  validateAuthDataComplete(e) {
    return P.validateAuthDataComplete(e);
  }
  isAccessTokenExpired() {
    return P.isAccessTokenExpired();
  }
  isRefreshTokenExpired() {
    const e = P.getAuthData();
    return e ? P.isRefreshTokenExpired(e.refresh_token) : !0;
  }
  /** Checks whether refresh token is supported. */
  isSupported() {
    return J(this, void 0, void 0, function* () {
      if (!hs.isElectron())
        return !0;
      const e = yield hs.getVersion();
      return zT(e, "3.7.0") === 1;
    });
  }
  /**
   * Gets refreshed tokens from the API
   *
   * @param refreshToken The refresh token.
   * @param retriesLeft The number of retries left.
   */
  refresh(e) {
    return J(this, arguments, void 0, function* (t, n = RE) {
      try {
        return yield Ju.post(`${Yr.url.rest}/v2/login/refresh`, {
          refreshToken: t
        }).then((a) => (this.retryCount = 0, a.data.data));
      } catch (a) {
        return yield this.handleRefreshError(a, t, n);
      }
    });
  }
  waitUntilOnline() {
    return J(this, void 0, void 0, function* () {
      const e = navigator.onLine === !1;
      for (e && (W("AUTH", "Network connection offline - waiting..."), ir({
        category: "refreshToken",
        message: "Network connection offline - waiting...",
        level: "debug"
      })); navigator.onLine === !1; )
        yield Es(5);
      e && (W("AUTH", "Network connection restored"), ir({
        category: "refreshToken",
        message: "Network connection restored",
        level: "debug"
      }));
    });
  }
  retryRefresh(e, t) {
    return J(this, void 0, void 0, function* () {
      yield this.waitUntilOnline(), this.retryCount++;
      const n = PE(this.retryCount);
      return W("AUTH", `Retrying in ${n} seconds`), yield Es(n), yield this.refresh(e, t);
    });
  }
  handleRefreshError(e, t, n) {
    return J(this, void 0, void 0, function* () {
      var a;
      if (P.isRefreshTokenExpired(t))
        return W("AUTH", "Refresh token expired"), ir({
          category: "refreshToken",
          message: "Refresh token expired",
          level: "debug"
        }), P.removeAuthData(), Ue(), null;
      if (Xu(e)) {
        if (e.message === "timeout exceeded")
          return W("AUTH", "Timeout exceeded"), ir({
            category: "refreshToken",
            message: "Timeout exceeded",
            level: "debug"
          }), yield this.retryRefresh(t, n);
        if (e.message === "Network Error")
          return W("AUTH", "Network error"), ir({
            category: "refreshToken",
            message: "Network error",
            level: "debug"
          }), yield this.retryRefresh(t, n);
        if (((a = e.response) === null || a === void 0 ? void 0 : a.status) === 401)
          return W("AUTH", "Refresh token invalid (401)"), P.removeAuthData(), Ue(), null;
        Ts(e, {
          level: "error",
          tags: {
            team: Xr.Platform,
            errorSource: "authManager.refresh"
          }
        });
      }
      return n <= 0 ? (W("AUTH", "Retries exhausted, logging out"), Ts(e, {
        level: "error",
        tags: {
          team: Xr.Platform,
          errorSource: "authManager.refresh"
        }
      }), P.removeAuthData(), Ue(), null) : (W("AUTH", `Retrying ${n} more times`), yield this.retryRefresh(t, n - 1));
    });
  }
  accessTokenExpiresInMs() {
    return P.accessTokenExpiresInMs();
  }
}
const Ja = new CE();
var ua;
(function(r) {
  r[r.BadRequest = 400] = "BadRequest", r[r.Unauthorized = 401] = "Unauthorized", r[r.Forbidden = 403] = "Forbidden", r[r.NotFound = 404] = "NotFound", r[r.Conflict = 409] = "Conflict", r[r.InternalServerError = 500] = "InternalServerError", r[r.BadGateway = 502] = "BadGateway", r[r.ServiceUnavailable = 503] = "ServiceUnavailable";
})(ua || (ua = {}));
const AE = ws.create();
class DE {
  /** The current logged in user. */
  user = null;
  /** The list of authorization scopes assigned to the current user. */
  scopes = null;
  /** This list of user roles assigned to the current user */
  _roles = null;
  /** Checks if the service has been initialized. */
  get isInitialized() {
    return this.user !== null;
  }
  /** Initializes the access control service. */
  async init({
    user: e
  }) {
    this.user = e;
    const t = await this.introspectAccessToken();
    t && (this.scopes = t.scope, this._roles = t.roles);
  }
  /** Exposed read-only list of user roles assigned to the current user */
  get roles() {
    return this._roles;
  }
  /**
   * Checks if the current user has access to one or more scopes.
   *
   * @param scopes - The scope(s) to check.
   * @param options - The options to use when checking multiple scopes.
   * @param options.strategy - The strategy to use when checking multiple
   *   scopes. Can be "all" or "any".
   * @returns Whether or not the user has access to the scope(s).
   */
  hasAccess(e, t) {
    if (!this.isInitialized || this.scopes === null)
      return !1;
    if (Array.isArray(e)) {
      const { strategy: n = "all" } = t ?? {};
      return n === "all" ? e.every(this.hasScope) : e.some(this.hasScope);
    }
    return this.scopes.includes(e);
  }
  /** Checks if the user has a certain scope. */
  hasScope = (e) => this.scopes.includes(e);
  /**
   * Fetches the introspection data of the current access_token and stores it in
   * memory. This should be called only once on init.
   */
  async introspectAccessToken() {
    const e = await Ja.getAuthData({ localStorageOnly: !0 });
    if (!e) return null;
    try {
      return (await AE.post(
        `${Yr.url.rest}/v1/introspect`,
        {
          token: e.access_token
        },
        {
          transformResponse: (n) => {
            const a = JSON.parse(n);
            return {
              ...a,
              /**
               * As per the spec, the backend returns the `scope` as a
               * space-separated string. We convert it to an array of strings to
               * make it easier for us.
               *
               * @see https://datatracker.ietf.org/doc/html/rfc7662#section-2.2
               */
              scope: a.scope ? a.scope.split(" ") : []
            };
          }
        }
      )).data;
    } catch {
      return null;
    }
  }
  reset() {
    this.user = null, this.scopes = null, this._roles = null;
  }
}
const jE = new DE(), kE = (r, e) => Qu(
  () => jE.hasAccess(r, e),
  // The arguments are statically defined when consuming the hook, therefore we don't need to
  // recompute the result on every render.
  // eslint-disable-next-line react-hooks/exhaustive-deps
  []
);
export {
  jE as accessControl,
  kE as useHasAccess
};
//# sourceMappingURL=index.js.map
